import { Component, OnInit, Input, Output, EventEmitter, Injectable, ChangeDetectionStrategy, ViewChild } from '@angular/core';
import { CommonService } from '../../../../commons/services/common.service';
import { NgbDateAdapter, NgbDateParserFormatter, NgbDatepickerI18n } from '@ng-bootstrap/ng-bootstrap';
import {
  I18n, CustomDatepickerI18n, NgbDateCustomParserFormatter,
  NgbDateNativeAdapter
} from '../../../../commons/input-date/injection-datepicker';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { Subject, Subscription } from 'rxjs';
import moment from 'moment';
// import * as $$ from 'jquery';
import { ConstanteEcorec } from '../../../../recylog/application/constante.ecorec';
import { GestionSite } from '../../../../recylog/application/gestion.site';
import { GestionBon } from '../../../../recylog/application/gestion.bon';
import { GestionFormat } from '../../../../recylog/application/gestion.format';
import { GestionBsdd } from '../../../../recylog/application/gestion.bsdd';
import { AlertService } from '../../../../commons/services/alert.service';
import { DragulaService } from 'ng2-dragula';
import { runInThisContext } from 'vm';

declare var jquery: any;
declare var $: any;

@Component({
    selector: 'app-create-mvt-devis',
    // changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './create-mvt-devis.component.html',
    styleUrls: ['./create-mvt-devis.component.css'],
    providers: [I18n, { provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n },
        { provide: NgbDateAdapter, useClass: NgbDateNativeAdapter },
        { provide: NgbDateParserFormatter, useClass: NgbDateCustomParserFormatter }],
    standalone: false
})
export class CreateMvtDevisComponent implements OnInit {
  showFicheclt: Boolean = false;
  showLeft: Boolean = false;
  showFichechantier: any = false;
  dataClient = [];
  listChantier = [];
  selectedEvent: any = {};
  eventSelected: any = {};
  selectedChantier: any = {};
  newprest: any = {};
  step = 1;
  date = new Date();
  addClient: Boolean = false;
  addChantier: Boolean = false;
  isEditChantier: Boolean = false;
  isEditContenant: Boolean = false;
  isModifier: Boolean = false;
  disableModif: Boolean = false;
  isModifDateVidage: Boolean = false;
  listcontenant = [];
  listExutoire = [];
  listChantierBenne = [];
  typeContenant = [];
  listArticle = [];
  newBenne = {};
  groupId = [];
  defaultExutoir: any = false;
  selectContenant = {};
  benneChantier = {};
  typeOperation = [];
  formatPerso = [];
  templistJourFerie = [];
  listJourFerie = [];
  immatriculationCamionSsChauffeur = '';

  listOperationNew = [
    { id: 0, libelleObjetEntite: 'Depot' },
  ];
  listOperationBenne = [
    { id: 2, libelleObjetEntite: 'Rotation' },
    { id: 1, libelleObjetEntite: 'Retrait' },
  ];
  defaultSelected;
  numBonManuelObligatoire: Boolean = false;
  isVidage: Boolean = false;
  showDate: Boolean = false;
  nbdigit = 0;
  default = 0;
  mouvement: any = {};
  raisonReport = '';
  formatprs: String = '';
  raisonSuppression: String = '';
  error = '';
  listeMouvSupp = [];
  showContrat: Boolean = false;
  isPricipal: Boolean = false;
  isCreateWithBtn: Boolean = false;
  isRetrait: Boolean = false;
  isShowSite: Boolean = false;
  isClicked: Boolean = false;
  updateAll: Boolean = false;
  isJourFerie: Boolean = false;
  isSuspension: Boolean = false;
  isAddContTournee: Boolean = false;
  deposerContenant: Boolean = false;
  showEditBtn: Boolean = false;
  isModifierLeContenant: Boolean = false;
  listeSite = [];
  listeSiteCA = [];
  defaultSite: any = {};
  detailTournee;
  client: any = {};
  isProgrammation: Boolean = false;
  isMouvSupp: Boolean = false;

  listProgram = [
    { id: 1, libelleObjetEntite: 'Jour du mois' },
    { id: 0, libelleObjetEntite: 'Jour de la semaine' },
    { id: 2, libelleObjetEntite: 'Jour et semaine du mois' },
    { id: 3, libelleObjetEntite: 'Dernière semaine du mois' },
  ];

  listSemaine = [
    { id: 2, libelleObjetEntite: 'LUN' },
    { id: 3, libelleObjetEntite: 'MAR' },
    { id: 4, libelleObjetEntite: 'MER' },
    { id: 5, libelleObjetEntite: 'JEU' },
    { id: 6, libelleObjetEntite: 'VEN' },
    { id: 7, libelleObjetEntite: 'SAM' },
    { id: 1, libelleObjetEntite: 'DIM' },
  ];

  listJour = [];
  nbSemainesProgram = '1';
  mouvBenneProgramme: any = {};
  tempMvtProgramme: any = {};
  listBenneSelected = [];
  contenantGoupe: any = { isGroupeBenne: true };
  societe: any = {};

  subs = new Subscription();
  BAG = 'DRAGULA_EVENTS';

  contenantDepot: any = {};
  listContDepot: any = [];
  addDepotCont: Boolean = false;
  listOperationDepot: any = [];
  listTypeContDepot: any = [];
  dataArticleDepot: any = [];
  contenantFact: any = {};

  addArticle: Boolean = false;
  selactedArticle: any = {};
  delay;


  @Input() info;
  @Input() addContenant;
  @Input() editContenant;
  @Input() edit;
  @Input() isPlanningLocked;
  @Input() isHisto;
  @Input() isGroupe;
  @Input() notEditable;
  @Input() isDmdEcoGED;
  @Input() isHistoMvt;

  @Output() observerMvtCreated = new EventEmitter<any>();
  @Output() close = new EventEmitter<any>();
  @Output() showalert = new EventEmitter<any>();
  @Output() updateDate = new EventEmitter<any>();

  @ViewChild('changedate') changedate;
  @ViewChild('confirmeImpBonSansChauffeur') confirmeImpBonSansChauffeur;
  @ViewChild('format') format;
  @ViewChild('dialogueSuppression') dialogueSuppression;
  @ViewChild('programConfirme') programConfirme;
  @ViewChild('msg') msg;
  @ViewChild('msgFormat') msgFormat;
  isClickFacturation: boolean;

  constructor(public common: CommonService, private modalService: BsModalService,
    protected alert: AlertService, private dragulaService: DragulaService) {
    this.subs.add(dragulaService.drop(this.BAG)
      .subscribe(({ el }) => {
        // this.addClass(el, 'ex-moved');
        const id = $(el).attr('id');
        console.log(this.detailTournee['listeContenants'])
      })
    );
  }

  ngOnInit() {
    const listeSite = this.common.local.getObject('listeSite') || [];
    for (let i = 0; i < 31; i++) {
      this.listJour.push({ id: i + 1, libelleObjetEntite: i + 1 });
    }
    const listSupp = [{ id: -1, libelleObjetEntite: 1 },
    { id: -1, libelleObjetEntite: 2 },
    { id: -1, libelleObjetEntite: 3 },
    { id: -1, libelleObjetEntite: 4 }];
    this.listJour = [...this.listJour, ...listSupp];
    if (!listeSite.length) {
      this.getListeSite();
    } else {
      this.isShowSite = listeSite.length > 1 ? true : false;
      this.listeSite = listeSite;
      this.listeSite.forEach(elt => {
        if (elt.id === this.common.user[2]) {
          this.defaultSite = elt;
        }
      });
    }
    this.isModifierLeContenant = false;
    this.showEditBtn = false;

    this.societe = this.common.local.getObject('paramSociete') || {};
    const list = this.common.getType('listOperationSupp') || [];
    this.nbdigit = this.common.local.getObject('paramSociete').nbDigitDevise || 0;
    this.showContrat = this.common.local.getObject('paramSociete').refContratBenne ? true : false;
    // this.numBonManuelObligatoire = this.common.local.getObject('paramSociete').numBonManuelObligatoire ? true : false;
    list.forEach(elt => elt.libelleObjetEntite = elt.libelle);
    const list2 = this.common.getType('listOperationSuppBennePlace') || [];
    list2.forEach(elt => elt.libelleObjetEntite = elt.libelle);
    this.listOperationNew.push(...list);
    this.listOperationBenne.push(...list2);
    this.showLeft = true;
    this.defaultExutoir = false;
    this.isPricipal = true;
    this.newprest['isImportant'] = false;
    this.newprest['dateStart'] = this.common.parseDate(moment().add(1, 'days').format('DD/MM/YYYY'));
    this.searchTypecontenant();
    this.detectIfAdd();
  }

  detectIfAdd() {
    this.listContDepot = [];
    this.newprest['dateStart'] = this.common.parseDate(moment().add(1, 'days').format('DD/MM/YYYY'));
    this.newBenne['dateDebutLoc'] = this.common.parseDate(moment().add(1, 'days').format('DD/MM/YYYY'));
    if (this.societe['gestionDateMax']) {
      this.newprest['dateMaxStart'] = this.common.parseDate(moment().add(1, 'days').format('DD/MM/YYYY'));
    }
    if (this.addContenant) {
      this.newprest['client'] = this.info['client'];
      this.getDetailClient(this.newprest['client'].id).then(() => {
        this.newBenne['isLocation'] = (this.societe['isLocation'] || this.client['isLoc']) ? true : false;
        this.getValeurDateMax();
      });
      this.newprest['chantier'] = this.info['chantier'];
      this.selectedChantier = this.info['chantier'];
      this.newprest['adresse'] = 'test';
      this.newprest['newContenant'] = true;
      this.newprest['typeContenant'] = this.info['typeContenant'];
      this.newBenne['typeContenant'] = this.info['typeContenant'];
      this.newprest['artDepot'] = this.info['artDepot'];
      this.step = 4;
      this.isPricipal = true;

      this.getDetailArticle(this.newprest['artDepot'].id).then(datas => {
        this.newprest['artDepot'] = datas.data[0];
        this.info['artDepot'] = datas.data[0];
        console.log('newArticle');
        console.log(this.newprest['artDepot']);
      });
      console.log(this.newprest);
      this.focusStep();
    }
  }

  getListArticleGrp(id) {
    const param = {
      'servlet': 'DBGetGroupeArticle',
      'module': 'Ecobennes',
      'type': 'tableau',
      'compression': 'false',
      'data': ['DBGetGroupeArticle', '' + id, '1']
    };


    return this.common.post('', { param: param }).then(datas => {
      if (datas.data) {
        this.newprest['contenant'].listArticles = datas.data || [];
        this.newprest['contenant'].listArticle = [];
        this.newprest['contenant'].listArticles = this.newprest['contenant'].listArticles || [];
        this.newprest['contenant'].listArticles.forEach(elt => {
          const art = {};
          art['art'] = Object.assign({}, elt);
          art['exutoire'] = Object.assign({}, elt.exu);
          this.newprest['contenant'].listArticle.push(art);
        });

        console.log(this.newprest['contenant'].listArticle)
      }
    });

  }

  mvtProgramme() {
    if (this.mouvBenneProgramme['id']) {
      if (this.mouvBenneProgramme['typeOperation']) {
        this.listProgram.forEach(elt => {
          if (elt.id === this.mouvBenneProgramme['typeOperation']) {
            this.mouvBenneProgramme['typeProgram'] = elt;
          }
        });
      } else {
        this.mouvBenneProgramme['typeProgram'] = this.listProgram[1];
      }
      if (this.mouvBenneProgramme['dateFin']) {
        this.mouvBenneProgramme['editDate'] = true;
        if (this.mouvBenneProgramme['dateFin'] !== '01/01/1970 00:00:00') {
          this.mouvBenneProgramme['datePgm'] = this.common.parseDate(moment((this.mouvBenneProgramme['dateFin']),
            'DD/MM/YYYY HH:mm:ss').format('DD/MM/YYYY'));
        } else {
          this.mouvBenneProgramme['datePgm'] = this.common.parseDate('31/12/9999');
        }
      }
      this.mouvBenneProgramme['nbSemainesProgram'] = '' + (this.mouvBenneProgramme['nbSemainesProgram'] || 1);
      this.mouvBenneProgramme['frequence'] = this.mouvBenneProgramme['frequence'] || 0;
      this.mouvBenneProgramme['listTtSemaine'] = [];
      this.mouvBenneProgramme['listSemainePaire'] = [];
      this.mouvBenneProgramme['listSemaineImpaire'] = [];
      this.mouvBenneProgramme['listJoursMois'] = [];
      this.mouvBenneProgramme['listJoursMois1'] = [];
      this.mouvBenneProgramme['listJoursMois2'] = [];
      this.mouvBenneProgramme['listJoursMois3'] = [];
      this.mouvBenneProgramme['listJoursMois4'] = [];
      this.mouvBenneProgramme['listJoursMois5'] = [];
      this.mouvBenneProgramme['listJoursDerSemaineMois'] = [];
      this.mouvBenneProgramme['listePeriodesPause'] = this.mouvBenneProgramme['listePeriodesPause'] || [];
      this.mouvBenneProgramme['typeOperation'] = this.mouvBenneProgramme['typeOperation'] || 0;
      switch (this.mouvBenneProgramme['typeOperation']) {
        case 0:
          if (this.mouvBenneProgramme['nbSemainesProgram'] === '1') {
            this.mouvBenneProgramme['listTtSemaine'] = this.mouvBenneProgramme['listJours'] || [];
          } else {
            this.mouvBenneProgramme['listSemainePaire'] = this.mouvBenneProgramme['listJoursSemaine2'] || [];
            this.mouvBenneProgramme['listSemaineImpaire'] = this.mouvBenneProgramme['listJours'] || [];
          }
          break;
        case 1:
          this.mouvBenneProgramme['listJoursMois'] = this.mouvBenneProgramme['listJours'] || [];
          break;
        case 2:
          this.mouvBenneProgramme['listJoursMois1'] = this.mouvBenneProgramme['listJours'] || [];
          this.mouvBenneProgramme['listJoursMois2'] = this.mouvBenneProgramme['listJoursSemaine2'] || [];
          this.mouvBenneProgramme['listJoursMois3'] = this.mouvBenneProgramme['listJoursSemaine3'] || [];
          this.mouvBenneProgramme['listJoursMois4'] = this.mouvBenneProgramme['listJoursSemaine4'] || [];
          this.mouvBenneProgramme['listJoursMois5'] = this.mouvBenneProgramme['listJoursSemaine5'] || [];
          break;
        case 3:
          this.mouvBenneProgramme['listJoursDerSemaineMois'] = this.mouvBenneProgramme['listJours'] || [];
          break;
      }
      this.tempMvtProgramme = Object.assign({}, this.mouvBenneProgramme);

    }
  }

  modifProgram() {
    let isModif = false;
    const listTtSemaine = this.mouvBenneProgramme['listTtSemaine'].length ? true : false,
      listSemainePaire = this.mouvBenneProgramme['listSemainePaire'].length ? true : false,
      listSemaineImpaire = this.mouvBenneProgramme['listSemaineImpaire'].length ? true : false,
      listJoursMois = this.mouvBenneProgramme['listJoursMois'].length ? true : false,
      listJoursMois1 = this.mouvBenneProgramme['listJoursMois1'].length ? true : false,
      listJoursMois2 = this.mouvBenneProgramme['listJoursMois2'].length ? true : false,
      listJoursMois3 = this.mouvBenneProgramme['listJoursMois3'].length ? true : false,
      listJoursMois4 = this.mouvBenneProgramme['listJoursMois4'].length ? true : false,
      listJoursMois5 = this.mouvBenneProgramme['listJoursMois5'].length ? true : false,
      listJoursDerSemaineMois = this.mouvBenneProgramme['listJoursDerSemaineMois'].length ? true : false;
    if (listTtSemaine || listSemainePaire || listSemaineImpaire || listJoursMois || listJoursMois1 || listJoursMois2
      || listJoursMois3 || listJoursMois4 || listJoursMois5 || listJoursDerSemaineMois) {
      isModif = true;
    }
    return isModif;
  }

  createObjtMvtBennePgm() {
    if (this.mouvBenneProgramme['tableConfigJoursFeries']) {
      this.mouvBenneProgramme['tableConfigJoursFeries'].forEach(elt => {
        if (elt.configJourFerie) {
          elt.configJourFerie.rattrapageLendemain = elt.configJourFerie.rattrapageLendemain || false;
        }
      });
    }
    const mouv = {
      id: this.mouvBenneProgramme['id'] || 0,
      typeOperation: this.mouvBenneProgramme['typeOperation'],
      frequence: this.mouvBenneProgramme['frequence'],
      tableConfigJoursFeries: this.mouvBenneProgramme['tableConfigJoursFeries'],
      listePeriodesPause: this.mouvBenneProgramme['listePeriodesPause'],
      nomclass: 'MouvementBenneProgramme',
    };
    switch (this.mouvBenneProgramme['typeOperation']) {
      case 0:
        mouv['nbSemainesProgram'] = this.mouvBenneProgramme['nbSemainesProgram'];
        if (this.mouvBenneProgramme['nbSemainesProgram'] === '1') {
          mouv['listJours'] = this.mouvBenneProgramme['listTtSemaine'] || [];
        } else {
          // mouv['listJours'] = this.mouvBenneProgramme['listSemainePaire'] || [];
          // mouv['listJoursSemaine2'] = this.mouvBenneProgramme['listSemaineImpaire'] || [];
          mouv['listJours'] = this.mouvBenneProgramme['listSemaineImpaire'] || [];
          mouv['listJoursSemaine2'] = this.mouvBenneProgramme['listSemainePaire'] || [];
        }
        break;
      case 1:
        mouv['listJours'] = this.mouvBenneProgramme['listJoursMois'] || [];
        break;
      case 2:
        mouv['listJours'] = this.mouvBenneProgramme['listJoursMois1'] || [];
        mouv['listJoursSemaine2'] = this.mouvBenneProgramme['listJoursMois2'] || [];
        mouv['listJoursSemaine3'] = this.mouvBenneProgramme['listJoursMois3'] || [];
        mouv['listJoursSemaine4'] = this.mouvBenneProgramme['listJoursMois4'] || [];
        mouv['listJoursSemaine5'] = this.mouvBenneProgramme['listJoursMois5'] || [];
        break;
      case 3:
        mouv['listJours'] = this.mouvBenneProgramme['listJoursDerSemaineMois'] || [];
        break;
    }

    if (this.mouvBenneProgramme['editDate']) {
      console.log(this.mouvBenneProgramme['datePgm'])
      if (this.mouvBenneProgramme['datePgm'] && typeof this.mouvBenneProgramme['datePgm'] === 'string' &&
        this.mouvBenneProgramme['datePgm'].match(/^(0?[1-9]|[12][0-9]|3[01])[\/\-](0?[1-9]|1[012])[\/\-]\d{4}$/)) {
        mouv['dateFin'] = this.mouvBenneProgramme['datePgm'];
      } else {
        if (moment(this.mouvBenneProgramme['datePgm']).isValid()) {
          mouv['dateFin'] = moment(this.mouvBenneProgramme['datePgm']).format('DD/MM/YYYY');
        }
        if (!this.mouvBenneProgramme['datePgm'] || this.mouvBenneProgramme['datePgm'] === '') {
          mouv['dateFin'] = '31/12/9999';
        }
      }
    }

    return mouv;
  }

  selectedDay(list, elem) {
    if (elem > 0) {
      const listfilter = list.filter(elt => parseInt(elt, 10) === parseInt(elem, 10));
      return listfilter.length ? true : false;
    } else {
      return false;
    }
  }

  selectedSemaine(list, elem) {
    list = list || [];
    const listfilter = list.filter(elt => parseInt(elt, 10) === parseInt(elem, 10));
    return listfilter.length ? true : false;
  }

  checkDayWeek(list, elem) {
    // let list = [];

    const listfilter = list.filter(elt => parseInt(elt, 10) === parseInt(elem, 10));
    if (listfilter.length) {
      let index;
      list.forEach((elt, idx) => {
        if (parseInt(elt, 10) === parseInt(elem, 10)) {
          index = idx;
        }
      });
      // const index = list.indexOf('' + 5);
      list.splice(index, 1);
      list = [...list];
    } else {
      list.push('' + elem);
      list = [...list];
    }
  }

  changeDateStart(event) {
    clearTimeout(this.delay);
    const ctrl = this;
    if (typeof event === 'string' && event.match(/^(0?[1-9]|[12][0-9]|3[01])[\/\-](0?[1-9]|1[012])[\/\-]\d{4}$/)) {
      ctrl.newprest['dateStart'] = ctrl.common.parseDate(event);
    }
    if (this.isVidage) {
      this.isModifDateVidage = true;
    }

    if (this.societe['gestionDateMax']) {
      if (!this.edit) {
        if (moment(ctrl.newprest['dateStart']).isAfter(ctrl.newprest['dateMaxStart'])) {
          ctrl.newprest['dateMaxStart'] = ctrl.newprest['dateStart'];
        }
      }
    }
  }


  modifContentContenant() {
    this.setValue(this.info['contenant'], 'contenant');
    this.editEvent(this.newprest, 5);
  }

  closeFunction() {
    this.isClicked = false;
    this.close.emit();
    this.selectedChantier = {};
    this.newprest = {};
    this.step = 1;
    this.newBenne = {};
  }

  selectDate(event, id) {
    this.common.focusElement(id);
  }

  focusStep() {
    switch (this.step) {
      case 1:
        setTimeout(function () {
          $('#autocomplete').focus();
        }, 550);
        break;
      case 2:
        setTimeout(function () {
          $('#autocomplete').focus();
        }, 550);
        break;
      case 3:
        setTimeout(function () {
          $('#autofocus').focus();
        }, 550);
        break;
      case 5:
        if (this.newprest['newContenant']) {
          setTimeout(function () {
            $('.articleCont').focus();
          }, 550);
        } else {
          setTimeout(function () {
            $('.articleCont').focus();
          }, 550);
        }
        break;
      case 6:
        if (!this.isEditContenant) {
          setTimeout(function () {
            $('[tabindex=0]').focus();
          }, 550);
        } else {
          setTimeout(function () {
            $('.typecontenant').click();
          }, 550);
        }
        break;
      case 6:
        setTimeout(function () {
          $('.exutoire').focus();
        }, 550);
        break;
      case 8:
        setTimeout(function () {
          $('.exutoire').focus();
        }, 550);
        break;
      case 8.1:
        setTimeout(function () {
          $('.combo').click();
        }, 550);
        break;
      case 4:
        setTimeout(function () {
          $('#date1').focus();
        }, 550);
        break;
      case 9:
        setTimeout(function () {
          // $('.sitePrest').click();
        }, 550);
        break;
      case 10:
        setTimeout(function () {
          $('#acompte').focus();
        }, 500);
        break;
      case 11:
        if (!this.newprest['showInfo']) {
          setTimeout(function () {
            $('[tabindex=0]').focus();
          }, 550);
        }
        break;
    }
  }

  getMargin() {
    let value;
    switch (this.step) {
      case 1:
        value = !this.edit ? '35px' : '-100px';
        break;
      case 2:
        value = !this.edit ? '15px' : '-100px';
        break;
      case 3:
        value = !this.edit ? '2px' : '-100px';
        break;
      case 4:
        value = !this.edit ? '-11px' : '-30px';
        break;
      case 5:
        value = !this.edit ? '-24px' : '-42px';
        break;
      case 6:
        value = !this.edit ? '-36px' : '-55px';
        break;
      case 7:
        value = !this.edit ? '-51px' : '-70px';
        break;
      case 8:
        value = !this.edit ? '-62px' : '-80px';
        break;
      case 8.1:
        value = !this.edit ? '-75px' : '-90px';
        break;
      case 9:
        value = !this.edit ? '-90px' : '-107px';
        break;
      case 10:
        value = !this.edit ? '-100px' : '-120px';
        break;
      case 11:
        value = !this.edit ? '-110px' : '-130px';
        break;
      default:
        value = '55px';
    }

    return value;
  }

  countRowsInText(text) {
    if (text) {
      const numerOfRowsInText = text.length ? text.split(/\r*\n/).length : 0;
      return numerOfRowsInText <= 3 ? 3 : 10;
    }
  }

  findCalendar(event) {
    if (event.target.id !== 'autocomplete') {
      if (this.common.dropdown) {
        this.common.dropdown.hide();
      }
    } else {
      if (this.common.dropdown && this.common.dropdown['ouvert']) {
        this.common.dropdown.show();
      }
    }
    if (event.target.id === 'date1' || event.target.id === 'date' || event.target.id === 'date2'
      || event.target.className === 'custom-select' || event.target.className === 'ngb-dp-navigation-chevron') {
      $('ngb-datepicker').addClass('show');
    } else {
      $('ngb-datepicker').removeClass('show');
      $('ngb-datepicker').hide();
    }
  }


  prevStep() {
    this.step = this.step > 1 ? this.step - 1 : 1;
    if (this.isGroupe && this.step === 5) {
      this.prevStep();
    }
    this.focusStep();
    if (this.step === 9 && !this.isShowSite) {
      this.prevStep();
    }

    if (this.step === 7) {
      this.prevStep();
    }
  }

  nextStep() {
    console.log('nextStep() called');
    if (!this.notValideChamp()) {
      this.step = this.step < 11 ? this.step + 1 : 11;
      if (this.step === 7) { // Sauter l'étape choix opération
        this.nextStep();
      }

      if (this.isGroupe && (this.step === 7 || this.step === 5)) {
        this.nextStep();
      }

      this.focusStep();
      if (this.step === 9 && !this.isShowSite) {
        this.nextStep();
      }
    }
  }

  notValideChamp() {
    let boolValue = false;
    switch (this.step) {
      case 1:
        if (!this.newprest['client'] || (this.newprest['client'] && !this.newprest['client'].id)) {
          $('#autocomplete').focus();
          this.newprest['client'] = false;
          boolValue = true;
          console.log('case 1 not valide');
        }
        break;
      case 2:
        if (!this.selectedChantier || (this.selectedChantier && !this.selectedChantier['id'])) {
          $('#autocomplete').focus();
          this.newprest['chantier'] = false;
          boolValue = true;
          console.log('case 2 not valide');
        }
        break;
      case 5:
        if (this.newprest['newContenant']) {
          if (!this.isGroupe) {
            console.log(this.newBenne);
            if (!this.newBenne['typeContenant'] || (this.newprest['typeContenant'] && !this.newprest['typeContenant'].id)) {
              $('.typecontenant').click();
              boolValue = true;
              console.log('case 4.1 not valide');
            } else {
              if (this.newBenne['isGroupeArticle']) {
                boolValue = false;
              } else {
                if (!this.newBenne['art'] || (this.newprest['art'] && !this.newprest['art'].id)) {
                  $('.articleCont').focus();
                  boolValue = true;
                  console.log('case 4.2 not valide');
                } else {
                  if (this.newBenne['isLocation'] && (!this.newBenne['dateDebutLoc'] || this.newBenne['dateDebutLoc'] === '')) {
                    boolValue = true;
                    $('#date2').focus();
                    console.log('case 4.3 not valide');
                  }
                }
              }
            }
          }

        } else {
          if (!this.newprest['contenant'] || (this.newprest['contenant'] && !this.newprest['contenant'].id)) {
            $('[tabindex=0]').focus();
            boolValue = true;
            console.log('case 4.3 not valide');
          }
        }
        break;
      case 8:
        if (!this.newprest['exutoire'] || (this.newprest['exutoire'] && !this.newprest['exutoire'].id)) {
          $('#autocomplete').focus();
          boolValue = true;
          console.log('case 6 not valide');
        }
        break;
    }

    return boolValue;
  }

  setFocuscalendar(event) {
    if (event.keyCode === 40 && event.target.nextElementSibling) {
      event.target.nextElementSibling.focus();
    }
  }

  showFiche() {
    this.showFicheclt = !this.showFicheclt;
  }

  createChantier(event) {
    event.nomclass = 'Chantier';
    event.siteChantier = this.common.user[2];
    const param = {
      'servlet': 'DBSaveChantierHolding',
      'module': 'Recylog',
      'type': 'liste',
      'compression': 'false',
      'data': [['DBSaveChantierHolding'], event, {
        id: this.newprest['client'] ? this.newprest['client'].id : 0,
        nomclass: 'Client'
      }]
    };
    this.hideChantier();
    this.common.post('', { param: param }).then(datas => {
      if (this.common.verifySession(datas)) {
        if (datas.data !== null) {

          if (datas.data[0]) {
            event['id'] = datas.data[0];
            this.getDetailChantier(datas.data[0]).then(dt => {
              const chantier = dt.data && dt.data.length ? dt.data[0] || event : event;
              this.selectedChantier = chantier;
              this.common.createLog('108', datas.data[0], true);
              this.newprest['chantier'] = this.selectedChantier;
              this.setValue(this.selectedChantier, 'chantier');
              // this.newprest['chantier'] = datas.data[0];
              setTimeout(function () {
                $('#autocomplete').focus();
              }, 500);
            });
          }
        }
      }
    });
  }

  hourMvt() {
    if (parseInt(this.newprest['hour'], 10)) {
      const heure = (this.newprest['hour'] || '00') + 'h' + (this.newprest['min'] || '00');
      return heure;
    } else {
      if (this.newprest['hour'] === '00') {
        const heure = (this.newprest['hour'] || '00') + 'h' + (this.newprest['min'] || '00');
        return heure;
      } else {
        return (this.newprest['hour']);
      }

    }
  }

  hideChantier() {
    this.isEditChantier = false;
    this.showFichechantier = false;
    this.addChantier = false;
  }

  updateChantier(event) {
    console.log(event);
  }

  showFicheCltadd() {
    this.addClient = !this.addClient;
    this.showFiche();
    if (!this.showFicheclt) {
      setTimeout(function () {
        $('#autocomplete').focus();
      }, 500);
    }
  }

  afterAddClt(event) {
    console.log(event);
    this.setValue(event, 'client');
    // this.newprest['client'] = event;
  }

  getChantier(id, edit?) {
    if (id) {
      this.getDetailChantier(id).then(datas => {
        this.isEditChantier = edit ? true : false;
        this.showFichechantier = datas.data[0];
        $('#slide-right').trigger('click');
      });
    } else {
      this.isEditChantier = true;
      this.showFichechantier = {};
      this.addChantier = true;
    }
  }

  getValeurDateMax() {
    if (this.societe['gestionDateMax']) {
      const param: any = {
        'servlet': 'DBGestionAngular',
        'module': 'Recylog',
        'type': 'map',
        'compression': 'false',
        'data': {
          'OPERATION': {
            'typeParam': 'int',
            'valeur': 23
          },
          'SITE': '' + (this.common.user[2] || 0),
          'NB_DATE_MAX': {
            'typeParam': 'int',
            'valeur': this.newprest['client'].dateMax || this.client['dateMax'] || 0
          },
        }
      };

      return this.common.post('', { param: param }).then(datas => {
        if (this.common.verifySession(datas)) {
          console.log(datas);
          if (datas.data) {
            this.newprest['dateMaxStart'] = this.common.parseDate(moment(datas.data,
              'DD/MM/YYYY HH:mm:ss').format('DD/MM/YYYY'));
          }
        }
      });
    }
  }

  getDetailChantier(id) {
    const param = {
      'servlet': 'DBGetChantier',
      'module': 'Recylog',
      'type': 'tableau',
      'compression': 'false',
      'data': ['DBGetChantier', id]
    };

    return this.common.post('', { param: param }).then(datas => {
      if (this.common.verifySession(datas)) {
        return datas;
      }
    });
  }

  showCreate() {
    this.newprest['newContenant'] = !this.newprest['newContenant'];
    this.newBenne = {};
    this.newBenne['dateDebutLoc'] = this.common.parseDate(moment().add(1, 'days').format('DD/MM/YYYY'));
    this.newBenne['isLocation'] = (this.societe['isLocation'] || this.client['isLoc']) ? true : false;
    this.newprest['contenant'] = false;
    setTimeout(function () {
      $('.combo').click();
    }, 550);
  }

  changeDateTest(event) {
    console.log(event);
  }

  getDetailClient(id) {
    const param = {
      'servlet': 'DBGetClient',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'true',
      'data': {
        'CLEF_CLIENT': {
          'typeParam': 'int',
          'valeur': id
        },
        'CLEF_SITE': {
          'typeParam': 'int',
          'valeur': this.common.user[2]
        },
        'LOAD_CHANTIER': {
          'typeParam': 'boolean',
          'valeur': false
        },
      }
    };

    return this.common.post('', { param: param }).then(datas => {
      if (this.common.verifySession(datas)) {
        this.client = datas.data ? datas.data[0] : {};
      }
    });
  }

  setValue(value, name?, isFirst?) {
    if (this.edit) {
      this.showLeft = false;
      this.isModifier = true;
      setTimeout(function () {
        $('#btnvalider').focus();
      }, 500);
    }

    if (name) {
      this.newprest[name] = value;
    }
    if (!this.notValideChamp()) {
      $('#autofocus').focus();
      /*if (name && name === 'client') {
        this.getListeContenant(this.newprest['client'].id);
      }*/
      if (name && name === 'client') {
        this.newprest['chantier'] = false;
        this.selectedChantier = {};
        this.newprest['adresse'] = false;
        if (value) {
          this.getDetailClient(value.id);
        }
      }

      if (name && name === 'chantier') {
        this.getListeContenant(this.newprest['client'].id, (this.newprest['chantier'].numChantier || ''));
      }

      if (name && name === 'cont') {
        this.isEditContenant = false;
      }

      if (name && name === 'newBenne') {
        if (!this.isDmdEcoGED) {
          this.typeOperation = this.listOperationNew;
          this.defaultSelected = this.typeOperation[0];
        }
        // this.typeOperation = this.listOperationNew;
        // this.defaultSelected = this.typeOperation[0];
        this.changeDatePlanning('dateDebutLoc');
      }
      if (name && name === 'contenant') {
        // this.typeOperation = this.listOperationBenne;
        // this.defaultSelected = this.typeOperation[0];
        if (!this.isDmdEcoGED) {
          this.typeOperation = this.listOperationBenne;
          this.defaultSelected = this.typeOperation[0];
        }
        value.dateDebutLoc = value ? this.common.parseDate(value.dateDebutLoc) : '01/01/2000';
        this.changeDatePlanning('dateDebutLoc', 'contenant');
        if (this.newprest['contenant'].typeContenant) {
          const elt = this.newprest['contenant'].typeContenant;
          this.newprest['contenant'].typeContenant.libelleObjetEntite = (elt.famille ? elt.famille.libelle + ' ' : '') +
            (elt.cubage ? (elt.cubage.cubage || 0) + ' ' : '') + (elt.uniteCont ? elt.uniteCont.libelle : '');
        }
        if (this.newprest['contenant'].art) {
          this.newprest['contenant'].art.libelleObjetEntite = this.newprest['contenant'].art.libelle;
        }

        if (!this.edit) {
          this.getDefaultExutoire(value);
        }

        if (value.isGroupeArticle) {
          this.getGroupeArt(value);
        }
        if (value.isGroupeBenne) {
          isFirst = isFirst || false;
          this.getGroupeBenne(value, isFirst);
        }
      }
      this.nextStep();

      if (this.step === 5) {
        this.getContenantCht();
        this.selectContenant = this.listcontenant[0];
        setTimeout(function () {
          $('[tabindex=0]').focus();
        }, 500);
      }
      if (this.step === 6) {
        setTimeout(function () {
          $('#autofocus2').focus();
        }, 500);
      }

      if (this.step === 7) {
        setTimeout(function () {
          $('.combo').click();
        }, 550);
        setTimeout(function () {
          $('[tabindex=0]').focus();
        }, 600);
      }

      if (this.step === 6) {
        this.isEditContenant = false;
      }
      if (this.step === 4) {
        setTimeout(function () {
          $('#date1').focus();
        }, 500);
      }

      if (this.step === 10) {
        setTimeout(function () {
          $('#acompte').focus();
        }, 500);
      }

      if (this.step === 11) {
        this.newprest['showInfo'] = false;
        setTimeout(function () {
          $('[tabindex=0]').focus();
        }, 500);
      }
    } else {
      console.log('champs invalides');
    }
  }

  searchClientNew(event) {
    const user = this.common.local.getObject('userDetail') || {};
    this.common.getModule();
    const activedModule = '' + this.common.activedModule;
    const fonctionUser = user.fonctionUser ? (user.fonctionUser.id || 0) : 0;
    const param = {
      'critere': event,
      'type': ['clients'],
      'afficherCodeNomClient': 'true',
      'afficherClientToutProspect': 'false',
      'afficherFactureAvoirNonHistorise': 'false',
      'clefSite': this.common.user[2],
      'clefUser': this.common.user[0],
      'clefFonction': fonctionUser,
      'clefModule': activedModule
    };

    this.common.searchEcoloc({ param: param }).then(datas => {
      // $('#autocomplete').trigger('click');
      if (this.common.verifySession(datas)) {
        this.dataClient = datas.data;
      }
    });
  }

  searchClient(event) {
    this.searchClientNew(event);
  }

  searchArticle(event, grp?) {
    const isNonSoumisFIP = this.client && this.client.id ? this.client?.isNonSoumisFIP || false : false;
    const isBlocageFIP = moment().month() !== 0 && this.societe.isBlocageFIP ? true : false;
    const param = isBlocageFIP && this.societe['gestionFIP'] && this.societe['isFIPCET'] && this.societe['compteGoodflag'] && !isNonSoumisFIP ? 57 : 14;
    const tab = isBlocageFIP && this.societe['gestionFIP'] && this.societe['isFIPCET'] && this.societe['compteGoodflag'] && !isNonSoumisFIP ? [{
      nom: 'CLEF_CLIENT', valeur: {
        'typeParam': 'int',
        'valeur': this.newprest.client && this.newprest.client.id ? this.newprest.client.id : 0
      }
    },
    {
      nom: 'CLEF_CHANTIER', valeur: {
        'typeParam': 'int',
        'valeur': this.newprest.chantier && this.newprest.chantier.id ? this.newprest.chantier.id : 0
      }
    }] : [];

    return this.common.appelComboK3Fct(param, event, tab).then(datas => {
      // $('#autocomplete').trigger('click');
      if (this.common.verifySession(datas)) {
        datas.data.forEach(elt => elt.libelle = elt.libelleObjetEntite);

        if (!grp) {
          this.listArticle = datas.data;
        } else {
          this.listArticle = [];
          const list = [];

          grp.forEach(g => {
            if (g.art && g.art.id) {
              list.push(g.art.id);
            }
          })

          datas.data.forEach(art => {
            if (art.id && list.indexOf(art.id)) {
              const exist = this.listArticle.filter(a => a.id === art.id);
              console.log(art);
              if (!exist.length) {
                this.listArticle.push(art);
              }
            }
          });
          console.log(this.listArticle)
        }
      }
    });
  }

  searchChantier(event) {
    const param = {
      'servlet': 'DBGetChantierClient',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {

        'SITE': {
          'typeParam': 'int',
          'valeur': this.common.user[2]
        },
        'CLEF_CLIENT': {
          'typeParam': 'int',
          'valeur': this.newprest['client'] ? this.newprest['client'].id : 0
        },
        'CRITERE': event
      }
    };
    const societe = this.common.local.getObject('paramSociete') || {};
    if (societe['visuChantierDateFin']) {
      param['data']['NBR_MOIS_VISU_CHANTIER'] = {
        'typeParam': 'int',
        'valeur': societe['nbrMoisVisuChantier'] || 0
      }
    }
    return this.common.post('', { param: param }).then(datas => {
      // $('#autocomplete').trigger('click');
      if (this.common.verifySession(datas)) {
        this.listChantier = datas.data;
      }
    });
  }

  getListeContenant(clt, cht?) {
    this.listChantierBenne = [];
    const param = {
      'servlet': 'DBRechercheClient',
      'module': 'Recylog',
      'type': 'tableau',
      'compression': 'true',
      'data': ['DBRechercheClient', '' + clt, '' + this.common.user[2], '' + (cht || '')]
    };

    return this.common.post('', { param: param }).then(datas => {
      if (datas.data && datas.data.length) {
        const chantier = datas.data[0].listChantier ? datas.data[0].listChantier : [];
        const listChantier = this.common.sortByText(chantier, 'numChantier');
        this.sortListeBenne(listChantier);
        this.listChantierBenne = listChantier;
        this.getContenantCht();
        $('.etape4').trigger('click');
      }
    }).catch(error => {
      console.log(error);
    });
  }

  getContenantCht() {
    // this.listcontenant = [];
    this.listChantierBenne.forEach(elt => {
      if (elt.id === this.newprest['chantier'].id) {
        elt.listBenne = elt.listBenne || [];
        if (this.isGroupe) {
          elt.listBenne.forEach(benne => {
            const exist = this.listcontenant.filter(ext => ext.id === benne.id)
            if (!benne.isGroupeBenne && !exist.length) {
              this.listcontenant.push(benne);
            }
          });
        } else {
          this.listcontenant = [];
          this.listcontenant.push(...elt.listBenne);
        }
      }
    });
    console.log(this.listcontenant)
  }

  nextFocus() {
    $('#infosup').focus();
  }

  sortListeBenne(listChantier) {
    listChantier.forEach(elt => {
      if (elt.listBenne) {
        elt.listBenne.sort(function (a, b) {
          if (a.isGroupeBenne || b.isGroupeBenne) {
            return (a.isGroupeBenne === b.isGroupeBenne) ? 0 : a.isGroupeBenne ? -1 : 1;
          } else {
            if (a.typeContenant && b.typeContenant) {
              if (a.typeContenant.famille && b.typeContenant.famille) {
                if (a.typeContenant.famille.libelle < b.typeContenant.famille.libelle) { return -1; }
                if (a.typeContenant.famille.libelle > b.typeContenant.famille.libelle) { return 1; }
              }

              if (a.typeContenant.cubage && b.typeContenant.cubage) {
                if (a.typeContenant.cubage.cubage < b.typeContenant.cubage.cubage) { return -1; }
                if (a.typeContenant.cubage.cubage > b.typeContenant.cubage.cubage) { return 1; }
              }

              if (a.art && b.art) {
                if (a.art.libelle < b.art.libelle) { return -1; }
                if (a.art.libelle > b.art.libelle) { return 1; }
              } else {
                return -1;
              }
            }
          }
          return 0;
        });
      }
    });
  }

  showInfoSupp(event) {
    this.newprest['showInfos'] = true;
    setTimeout(function () {
      $('[autofocus]').focus();
    }, 500);
  }

  changeFocus(event, i, value?) {
    if (event.keyCode === 40 && event.target.nextElementSibling) {
      event.target.nextElementSibling.focus();
      if (!value) {
        this.newprest['showInfo'] = !this.newprest['showInfo'];
      } else {
        this.newprest['showInfos'] = !this.newprest['showInfos'];
      }
    }
    if (event.keyCode === 38 && event.target.previousElementSibling) {
      event.target.previousElementSibling.focus();
      if (!value) {
        this.newprest['showInfo'] = !this.newprest['showInfo'];
      } else {
        this.newprest['showInfos'] = !this.newprest['showInfos'];
      }
    }
  }

  searchExutoire(event) {
    const idart = !this.newprest['newContenant'] ? (this.newprest['contenant'] ? (this.newprest['contenant'].art ?
      this.newprest['contenant'].art.id : 0) : 0) : (this.newprest['newBenne'] ? (this.newprest['newBenne'].art ?
        this.newprest['newBenne'].art.id : 0) : 0);
    const param = {
      'servlet': 'DBGetListeExuLimites',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 1
        },
        'CLEF_CHANTIER': {
          'typeParam': 'int',
          'valeur': this.newprest['chantier'] ? this.newprest['chantier'].id : 0
        },
        'CLEF_CLIENT': {
          'typeParam': 'int',
          'valeur': this.newprest['client'] ? this.newprest['client'].id : 0
        },
        'LIST_ARTICLES': this.groupId.length ? this.groupId : ['' + idart],
        'CRITERE_NOM_EXUTOIRE': event + '%'
      }
    };

    return this.common.post('', { param: param }).then(datas => {
      // $('#autocomplete').trigger('click');
      if (this.common.verifySession(datas)) {
        if (datas.data && datas.data.length) {
          datas.data.forEach(elt => elt.libelleObjetEntite = elt.nom || elt.libelleObjetEntite);
          this.listExutoire = datas.data;
        } else {
          this.anotheExutoire(event);
        }
      }
    });
  }

  anotheExutoire(event) {
    const param = 6;

    return this.common.appelComboK3Fct(param, event).then(datas => {
      // $('#autocomplete').trigger('click');
      if (this.common.verifySession(datas)) {
        this.listExutoire = datas.data;
      }
    });
  }

  hideCalendar() {
  }

  searchTypecontenant() {
  }

  searchTypecontenantByLibelle(event) {
    const listContenant = this.common.getType('listetypeContenant') || [];
    this.typeContenant = []; // { id: 0, libelleObjetEntite: 'Tous' }
    if (event !== '') {
      listContenant.forEach(elt => {
        elt.libelleObjetEntite = (elt.famille ? elt.famille.libelle + ' ' : '') + (elt.cubage ? (elt.cubage.cubage || 0) + ' ' : '') +
          (elt.uniteCont ? elt.uniteCont.libelle : '');
        const libelle = elt.libelleObjetEntite ? elt.libelleObjetEntite.toLowerCase() : '';
        if (libelle.includes(event.toLowerCase())) {
          this.typeContenant.push(elt);
        }
      });
    } else {
      listContenant.forEach(elt => {
        elt.libelleObjetEntite = (elt.famille ? elt.famille.libelle + ' ' : '') + (elt.cubage ? (elt.cubage.cubage || 0) + ' ' : '') +
          (elt.uniteCont ? elt.uniteCont.libelle : '');
        this.typeContenant.push(elt);
      });
    }
  }

  editEvent(event, step, idfocus?) {
    if (this.edit) {
      if (this.isVidage) {
        if (!this.isGroupe) {
          if (step === 8 || step === 5 || step === 6 || step === 11) {
            this.showLeft = true;
          }
        } else {
          this.isModifier = false;
        }
      } else {
        this.showLeft = true;
      }
    }

    if (!this.isVidage) {
      this.step = step;
    } else {
      if (this.showLeft) {
        if (step === 8 || step === 5 || step === 6 || step === 11) {
          this.step = step;
        }
      }
    }

    if (step === 5 && this.isGroupe) {
      this.step = 5;
    }

    if (this.step === 3) {
      setTimeout(function () {
        $('#autofocus').focus();
      }, 1000);
    }

    if (this.step === 8) {
      setTimeout(function () {
        $('.exutoire').focus();
      }, 1000);
    }

    if (this.step === 6) {
      setTimeout(function () {
        $('.combo').click();
      }, 600);
    }

    if (this.step === 7) {
      setTimeout(function () {
        $('.typeOperation').click();
      }, 550);
    }

    if (this.step === 4) {
      if (idfocus) {
        setTimeout(function () {
          $('#' + idfocus).focus();
        }, 100);
      } else {
        setTimeout(function () {
          $('#date1').focus();
        }, 100);
      }
    }

    if (this.step === 9) {
      setTimeout(function () {
        $('.sitePrest').click();
      }, 600);
    }

    if (this.step === 10) {
      if (idfocus) {
        setTimeout(function () {
          $(idfocus).focus();
        }, 100);
      } else {
        setTimeout(function () {
          $('#acompte').focus();
        }, 100);
      }
    }

    if (this.step === 11) {
      this.newprest['showInfos'] = true;
      this.newprest['showInfo'] = true;
      if (this.newprest['showInfo']) {
        if (idfocus) {
          setTimeout(function () {
            $(idfocus).focus();
          }, 100);
        } else {
          setTimeout(function () {
            $('#autofocus').focus();
          }, 100);
        }
      } else {
        setTimeout(function () {
          $('[tabindex=0]').focus();
        }, 500);
      }
    }
  }

  getDefaultExutoire(benne) {
    const param = {
      'servlet': 'DBGetExutoire',
      'module': 'Recylog',
      'type': 'tableau',
      'compression': 'false',
      'data': ['DBGetExutoire', '' + (benne['exu'] ? benne['exu'].id : '0')]
    };
    return this.common.post('', { param: param }).then(datas => {
      // $('#autocomplete').trigger('click');
      if (this.common.verifySession(datas)) {
        datas.data.forEach(elt => elt.libelleObjetEntite = elt.nom);
        if (datas.data[0].id) {
          this.defaultExutoir = datas.data[0];
        }
      }
    });
  }

  getGroupeArt(benne) {
    const param = {
      'servlet': 'DBGetGroupeArticle',
      'module': 'Ecobennes',
      'type': 'tableau',
      'compression': 'false',
      'data': ['DBGetGroupeArticle', '' + benne.id, '1']
    };
    return this.common.post('', { param: param }).then(datas => {
      // $('#autocomplete').trigger('click');
      if (this.common.verifySession(datas)) {
        datas.data.forEach(elt => this.groupId.push('' + elt.id));
        this.newprest['contenant'].listArticles = datas.data || [];
      }
    });
  }

  getGroupeBenne(benne, isFirst?) {
    const param = {
      'servlet': 'DBGetGroupeBennes',
      'module': 'Ecobennes',
      'type': 'tableau',
      'compression': 'false',
      'data': ['DBGetGroupeBennes', '' + benne.id, '0']
    };
    return this.common.post('', { param: param }).then(datas => {
      // $('#autocomplete').trigger('click');
      if (this.common.verifySession(datas)) {
        datas.data = datas.data || [];
        if (isFirst) {
          this.listcontenant = [...this.listcontenant, ...(datas.data || [])];
        }

        this.newprest['contenant'].listBennes = datas.data || [];
        this.listBenneSelected = datas.data || [];
        this.listBenneSelected = [...this.listBenneSelected, ...this.listContDepot];
      }
    });
  }

  isValidDate(dateString) {
    const regEx = /^\d{4}-\d{2}-\d{2}$/;
    return dateString.match(regEx) != null;
  }

  isRetraitFct() {
    return this.newprest['typeOperation'] && this.newprest['typeOperation'].id === 1 ? true : false;
  }

  testOperationGeneration(dt, isGroupe?) {
    console.log('testOperationGeneration()');
    console.log(dt);
    console.log(this.newprest);
  }

  generatePrestation() {
    console.log('generatePrestation() called');
    if (this.newprest['program'] && !this.modifProgram()) {
      this.error = 'Il faut sélectionner au moins un jour.';
      this.isClicked = false;
      this.common.openModal(this.modalService, this.msg);
      return;
    }

    const dateStart = moment(this.newprest['dateStart']).format('YYYY-MM-DD');
    if (!this.isValidDate(dateStart)) {
      this.error = 'La date n\'est pas valide.';
      this.isClicked = false;
      this.common.openModal(this.modalService, this.msg);
      return;
    }

    if (this.newprest['chantier']) { this.newprest['chantier'].nomclass = 'Chantier'; }
    if (this.newprest['client']) { this.newprest['client'].nomclass = 'Client'; }
    if (this.newprest['newContenant']) {
      this.newprest['newBenne'] = this.newprest['newBenne'] || {};
      this.newprest['newBenne'].exutoire = this.newprest ? this.newprest['exutoire'] : {};
      this.newprest['newBenne'].infoFact = this.newprest['infoFact'] || '';
      this.newprest['newBenne'].infoNextMouv = this.newprest['infoNextMouv'] || '';
      this.newprest['newBenne'].infos = this.newprest['infos'] || '';
      this.changeDatePlanning('dateDebutLoc', 'newBenne');
      this.benneChantier = this.newprest['newBenne'];
    } else {
      this.newprest['contenant'].exutoire = this.newprest['exutoire'];
      this.newprest['contenant'].infoFact = this.newprest['infoFact'] || '';
      this.newprest['contenant'].infoNextMouv = this.newprest['infoNextMouv'] || '';
      this.newprest['contenant'].infos = this.newprest['infos'] || '';
      this.changeDatePlanning('dateDebutLoc', 'contenant');
      this.benneChantier = this.newprest['contenant'];
    }

    if (this.benneChantier['isGroupeArticle'] && !this.benneChantier['listArticle'].length) {
      this.error = 'Votre groupe d\'article doit comporter au moins un article.';
      this.isClicked = false;
      this.common.openModal(this.modalService, this.msg);
      return;
    }

    if (this.benneChantier['listArticle']) {
      this.benneChantier['listArticles'] = [];
      this.benneChantier['listArticle'].forEach(elt => {
        const art = Object.assign({}, elt.art);
        art.exu = Object.assign({}, elt.exutoire);
        art.nomclass = 'Article';
        this.benneChantier['listArticles'].push(art);
      });
    }

    if (this.benneChantier['listBennes']) {
      this.benneChantier['listBennes'].forEach(elt => {
        if (elt.id < 0) {
          elt.id = 0;
        }
        elt.nomclass = 'BenneData';
        elt.operation = elt.operationBenne ? (elt.operationBenne['id'] || '2') : '2';
        elt.operationBenne = {
          id: elt.operationBenne ? (elt.operationBenne['id'] || '2') : '2'
        };
      });
    }

    const operation = [];
    operation.push(...this.listOperationBenne, ...this.listOperationNew);

    this.benneChantier['qteContenant'] = this.benneChantier['qteContenant'] ? parseInt(this.benneChantier['qteContenant'], 10) : 1;
    const isClient = this.newprest['client'] && this.newprest['client'].id ? true : false;
    const isChantier = this.newprest['chantier'] && this.newprest['chantier'].id ? true : false;
    const isArticle = this.benneChantier['isGroupeArticle'] ? true :
      (this.benneChantier['art'] && this.benneChantier['art'].id ? true : false);
    const isExutoire = this.newprest['exutoire'] && this.newprest['exutoire'].id ? true : false;
    const isTypecont = this.benneChantier['typeContenant'] && this.benneChantier['typeContenant'].id ? true : false;
    console.log(isClient, isChantier, isArticle, isExutoire, isTypecont);
    const isGoupe = this.benneChantier['isGroupeBenne'] || false;
    const listBennes = this.benneChantier['listBennes'] || [];

    console.log(this.newprest);

    if (!this.isClicked) {
      this.isClicked = true;
      if (isClient && isChantier && isArticle && isExutoire && isTypecont && !isGoupe) {
        if (this.newprest['newContenant']) {
          console.log('new contenant');
          this.creationMvt();
        } else {
          console.log('exist contenant');
          this.checkRetraitBenne().then(datas => {
            const dt = datas.data || {};
            this.testOperationGeneration(dt);

          }).catch(err => {
            this.isClicked = false;
          });
        }
      } else {
        // if (isGoupe && isClient && isChantier && isExutoire && isTypecont) {
        if (isGoupe && isClient && isChantier && isExutoire && listBennes.length) {
          if (listBennes.length) {
            if (this.newprest['newContenant']) {
              console.log('new contenant');
              this.creationMvt();
            } else {
              console.log('exist contenant');
              this.checkRetraitBenne().then(datas => {
                const dt = datas.data || {};
                this.testOperationGeneration(dt, true);
              }).catch(err => {
                this.isClicked = false;
              });
            }
          } else {
            this.isClicked = false;
            this.error = `Votre groupe de contenant doit comporter au moins un contenant`;
            this.common.openModal(this.modalService, this.msg);
          }
        } else {
          this.isClicked = false;
          this.error = `Veuillez renseigner tous les champs obligatoires. (client, chantier, article, type de contenant et exutoire)`;
          this.common.openModal(this.modalService, this.msg);
        }

      }
    }
  }

  closeModalError() {
    this.common.closeModal();
    if (this.isRetrait) {
      this.isRetrait = false;
      this.closeFunction();
    }
  }

  changeFocusCont(event, i) {
    if ((event.keyCode === 40) && event.target.nextElementSibling) {
      event.target.nextElementSibling.focus();
      this.selectContenant = this.listcontenant[i + 1];
    }
    if ((event.keyCode === 38) && event.target.previousElementSibling) {
      this.selectContenant = this.listcontenant[i - 1];
      event.target.previousElementSibling.focus();
    }
  }

  getDetailArticle(id) {
    const clef = '' + id;
    const param = {
      'servlet': 'DBGetArticle',
      'module': 'Recylog',
      'type': 'tableau',
      'compression': 'false',
      'forcerSerialisation': 'true',
      'data': ['DBGetArticle', clef]
    };
    return this.common.post('', { param: param });
  }

  // Devis
  creationMvt() {
    console.log('creationMvt() called');
    console.log(this.benneChantier);
    const sitePrest = this.isShowSite ? (this.newprest['sitePrest'] ? this.newprest['sitePrest'].id
      : this.common.user[2]) : this.common.user[2];

    console.log(this.newprest);
    const listMouv = this.newprest['mouvSupp'] ? this.newprest['listMouvSupp'] || [] : [];

    listMouv.forEach(element => {
      delete element.dateaffiche;
      delete element.operationAffiche;
      delete element.exutoire;
      delete element.sitePrest;
      delete element.infoNextMouv;
    });

    this.info['devis']['nomclass'] = 'Devis';
    this.info['artDepot']['nomclass'] = 'Article';
    const param = {
      'servlet': 'DBCreateMouvementBenne',
      'module': 'Ecocrm',
      'type': 'liste',
      'compression': 'false',
      'data': [
        { // 0
          'typeParam': 'string',
          'valeur': this.common.user[2] + '', // site
        },
        { // 1
          'typeParam': 'string',
          'valeur': this.common.user[0] + '', // user,
        },
        this.info['devis'], // devis
        this.info['artDepot'], // article devis
        { // 4
          'typeParam': 'string',
          'valeur': this.newprest['newBenne'] && this.newprest['newBenne'].art ? this.newprest['newBenne'].art.id + '' || '0' : '0', // article dans le contenant
        },
        { // 5
          'typeParam': 'string',
          'valeur': this.newprest['exutoire'] ? (this.newprest['exutoire'].id + '' || '0') : '0', // exutoire
        },
        { // 6
          'typeParam': 'string',
          'valeur': moment(this.newprest['dateStart']).format('DD/MM/YYYY'), // date demande
        },
        { // 7
          'typeParam': 'string',
          'valeur': this.newprest['chantier'] ? this.newprest['chantier'].id + '' || '0' : 0, // chantier
        },
        // this.newprest['program'] || false, // program
        this.newprest['program'] ? this.createObjtMvtBennePgm() : 'null', // program
        { // 9
          'typeParam': 'int',
          'valeur': sitePrest // this.newprest['sitePrest'].id || 0, // site prest
        },
        { // 10
          'typeParam': 'int',
          'valeur': this.common.user[2], // site ca
        },
        { // 11
          'typeParam': 'string',
          'valeur': this.newprest['hour'] || ''
          // ((this.newprest['hour'] || '00') + 'h' + (this.newprest['min'] || '00')), 
          // heure
        },
        listMouv, // plus de mouvement
        { // 13
          'typeParam': 'boolean',
          'valeur': this.newprest['auplustard'] ? true : false, // au plus tard
        },
        { // 14
          'typeParam': 'int',
          'valeur': this.info['quantite'] || 1, // quantité contenant
        },
        [ // facturation
          {
            'typeParam': 'boolean',
            'valeur': this.newprest['acompte'] && this.newprest['acompte'] > 0 ? true : false,
          },
          {
            'typeParam': 'double',
            'valeur': this.newprest['acompte'] ? parseFloat(this.newprest['acompte']).toFixed(2) : '0.00',
          },
          {
            'typeParam': 'boolean',
            'valeur': this.newprest['numContrat'] ? true : false,
          },
          {
            'typeParam': 'string',
            'valeur': this.newprest['numContrat'] || '',
          },
          {
            'typeParam': 'boolean',
            'valeur': this.benneChantier['isLocation'] || false,
          },
          {
            'typeParam': 'date',
            'valeur': this.benneChantier['dateDebutLoc'] ?
              (moment(this.benneChantier['dateDebutLoc']).format('DD/MM/YYYY') || '01/01/2000') : '01/01/2000',
          },
          {
            'typeParam': 'string',
            // 'valeur': this.benneChantier['infoNextMouv'], // Infos prestation (Info mouv dans l'ancienne version)
            'valeur': this.benneChantier['infoFact'], // Infos fact (Info mouv dans l'ancienne version)
          },
          {
            'typeParam': 'int',
            'valeur': this.benneChantier['typeLocation'] || 1, // Facturation -> type location
          },
          {
            'typeParam': 'boolean',
            'valeur': this.benneChantier['isLocImmediat'] || false, // Facturation -> immediat
          },
          {
            'typeParam': 'boolean',
            'valeur': this.benneChantier['isTarifLoc'] || false, // Facturation -> is tarif loc
          },
          {
            'typeParam': 'int',
            'valeur': this.benneChantier['tarifLoc'] || 0, // Facturation -> tarif loc
          },
          {
            'typeParam': 'int',
            'valeur': this.benneChantier['nbrRotTarifLoc'] || 0,
          },
          {
            'typeParam': 'boolean',
            'valeur': this.benneChantier['isLocJour'] || false,
          },
          {
            'typeParam': 'boolean',
            'valeur': this.benneChantier['isTarifRot'] || false,
          },
          {
            'typeParam': 'int',
            'valeur': this.benneChantier['tarifRot'] || 0,
          },
          {
            'typeParam': 'int',
            'valeur': this.benneChantier['nbrRotGratuite'] || 0,
          }
        ],
        { // 16
          'typeParam': 'boolean',
          'valeur': !this.info['artDepot'].opBenne.operationSurBenneEnPlace ? true : false /*idxBenne>0*/, // nePasVerifierDoublonContenant
        },
        { // 17
          'typeParam': 'string',
          // 'valeur': this.benneChantier['infos'], // Infos contenant (Info supp dans l'ancienne version)
          'valeur': this.benneChantier['infoNextMouv'], // Infos prestation (Info mouv dans l'ancienne version)
        },
        { // 18
          'typeParam': 'boolean',
          'valeur': this.benneChantier['isGroupeArticle'] || false, // est groupe d'article
        },
        this.benneChantier['listArticles'] || [], // liste articles dans le groupe
        { // 20
          'typeParam': 'string',
          'valeur': this.benneChantier['infos'], // Infos contenant (Info supp dans l'ancienne version)
        },
        { // 21
          'typeParam': 'string',
          'valeur': this.societe['gestionDateMax'] ? moment(this.newprest['dateMaxStart']
          ).format('DD/MM/YYYY') : moment(this.newprest['dateStart']
          ).format('DD/MM/YYYY'), // date max, champs à ajouter si societe.gestionDateMax
        },
      ]
    };

    return this.common.post('', { param: param }).then(datas => {
      console.log(datas);
      this.closeFunction();
      this.observerMvtCreated.emit(datas.data);
      this.detectIfAdd();
    });
  }

  hideFunction() {
    this.closeFunction();
    this.observerMvtCreated.emit();
  }

  focusDate(isLocation, id, benne?) {
    if (isLocation) {
      this.common.focusElement(id);
    }
  }

  changeDatePlanning(item, contenant?) {
    if (!contenant) {
      const val = this.newBenne[item];
      console.log(val);
      if (val && typeof val === 'string') {
        const type = val.match(/^(0?[1-9]|[12][0-9]|3[01])[\/\-](0?[1-9]|1[012])[\/\-]\d{4}$/) ? true : false;
        if (type) {
          this.newBenne[item] = this.common.parseDate(val);
          console.log(this.newBenne[item]);
        }
      }
    } else {
      if (contenant) {
        this.newprest[contenant] = this.newprest[contenant] || {};
        const val = this.newprest[contenant][item];
        console.log(val);
        if (val && typeof val === 'string') {
          const type = val.match(/^(0?[1-9]|[12][0-9]|3[01])[\/\-](0?[1-9]|1[012])[\/\-]\d{4}$/) ? true : false;
          if (type) {
            this.newprest[contenant][item] = this.common.parseDate(val);
            console.log(this.newprest[contenant][item]);
          }
        }
      }
    }

  }

  createTabData(mouv) {
    const isAjoutBenne = this.newprest['newContenant'] ? true : false;
    const progm = this.createObjtMvtBennePgm();
    const heure = ((this.newprest['hour'] || '00') + 'h' + (this.newprest['min'] || '00'));
    const famille = mouv['typeContenant'] ? (mouv['typeContenant'].famille ? mouv['typeContenant'].famille.id : '') : '0';
    const cubage = mouv['typeContenant'] ? (mouv['typeContenant'].cubage ? mouv['typeContenant'].cubage.id : '') : '0';
    const article = mouv['art'] ? mouv['art'].id : '0';
    const sitePrest = this.isShowSite ? (this.newprest['sitePrest'] ? this.newprest['sitePrest'].id
      : this.common.user[2]) : this.common.user[2];


    return [
      'DBAjoutMouv',
      '' + (mouv.important || false), // mouv.important (checkbox important, boolean)
      'false',
      '' + isAjoutBenne,
      '' + (this.benneChantier['commentairesFact'] || ''), // (bloc facturation->commentaireFact (String))
      '0', // (bloc demande (fax, tel, mail))
      this.newprest['numContrat'] || '', // (bloc facturation->numContrat (String))
      '0', // (mouvement.camion.id (String))
      '' + (this.benneChantier['nbrRotTarifLoc'] || 0), // (facturation.getNbrRotTarifLoc)
      '' + (this.benneChantier['isLocJour'] || false), // (isIsLocJour)
      this.newprest['numContrat'] ? 'true' : 'false', // (isContrat) false : valeur taloha
      '' + (this.benneChantier['nbrRotGratuite'] || 0), // getNbrRotGratuite
      '' + (this.benneChantier['tarifRot'] || 0), // getTarifRot
      '' + (this.benneChantier['isTarifRot'] ? 1 : 0), // isIsTarifRot
      '' + this.common.user[0], // user
      '0', // isAuPlusTard
      '' + this.newprest['client'].id, // client
      '' + (this.benneChantier['tarifLoc'] || 0), // getTarifLoc
      '' + (this.benneChantier['isTarifLoc'] || false), // isIsTarifLoc
      '' + (this.benneChantier['isLocImmediat'] || false), // isIsLocImmediat
      '0', // benne.getLieu().getId()
      '' + (this.benneChantier['typeLocation'] || 1), // benne.getTypeLocation()
      this.newprest['infoNextMouv'] || '', // Info. mouv panel.getInfosMouv();
      this.newprest['infoFact'] || '', // Information Sup. (String) ##### Info. mouv panel.getInfosMouv();
      '0', // duree
      moment().format('YYYY-MM-DD'),
      moment().format('HH:mm:ss'),
      moment(this.newprest['dateStart']).format('YYYY-MM-DD'),
      heure || '00h00', //  (Heure (String))
      this.newprest['acompte'] || '0', // montant : acompte
      '0',
      '' + (this.newprest['exutoire'] ? this.newprest['exutoire'].id : '0'),
      this.newprest['infos'] || '', // panel.getInfos : info supp
      '' + (this.newprest['typeOperation'] ? this.newprest['typeOperation'].id : '2'), // mouvement.operation ('2' par défaut (String))
      this.benneChantier['isGroupeArticle'] ? '1' : '0',  // index 34
      mouv.isGroupeBenne ? '1' : '0', // index 35
      '' + (this.newprest['program'] ? true : false), // isProgram (si programation)
      '' + this.newprest['chantier'].id,
      '' + famille,
      '' + cubage,
      '' + article,
      '' + sitePrest, // getClefSitePrest
      '' + this.common.user[2], // getClefSiteCA
      '' + mouv.isLocation, // isLocation
      // this.benneChantier['dateDebutLoc'] ? moment(this.benneChantier['dateDebutLoc']).format('DD/MM/YYYY') : '01/01/2000', // date debut loc
      this.benneChantier['dateDebutLoc'] ? moment(this.benneChantier['dateDebutLoc']).format('YYYY-MM-DD') : '2000-01-01', // date debut loc // point : 116778
      '0', // (mouv.getContrat().getId() (String))
      'false', // mouv.isReceptionChantier
      '2000-01-01',
      '',
      '0', // mouv.getCamionChantier().getClef()
      '0', // mouv.getChauffeurChantier().getClef()
      '0', // mouv.getPositionPlanningChantier()
      this.newprest['numBonManuel'] || '', // mouv.getBon().getNumBonManuel()
      '0', // mouv.getClefChauffeur()
      '0', // mouv.getPeriode().getId()
      moment().format('YYYY-MM-DD'), // date aujourd'hui (String)
      '' + (this.newprest['program'] ? progm['typeOperation'] : ''), // type prog si progm || ''
      '' + (this.newprest['program'] ? progm['frequence'] : ''), // frequence
      '0',
      '0',
      '0',
      '0'
    ];
  }

  modifContenant() {
    if (this.newprest['newBenne']) {
      this.isEditContenant = !this.isEditContenant;
      setTimeout(function () {
        $('.combo').click();
      }, 550);
    }
    if (this.newprest['contenant']) {
      if (!this.newprest['contenant'].isGroupeBenne) {
        this.isEditContenant = !this.isEditContenant;
        setTimeout(function () {
          $('.combo').click();
        }, 550);
      }
    }
  }

  updateClientChantier(notLog?) {
    if (!notLog && this.newprest) {
      this.common.createLog('108', this.newprest['chantier'] ? this.newprest['chantier'].id : 0, false);
    }
    this.closeFunction();
  }

  /**
   * FenetreAjout.java -> getDataBenneChantier(boolean addInfoNextMouv)
   */
  updateBenneChantier(isEdit?) {
    let tabUpdateBenneChantier;
    this.newprest['client'] = this.newprest['client'] || { id: '0' }; // debug !client
    this.newprest['client'].nomclass = 'Client';
    this.newprest['chantier'] = this.newprest['chantier'] || { id: '0' };
    this.newprest['chantier'].nomclass = 'Chantier';
    const mouvement = this.createObjMvt();
    this.changeDatePlanning('dateDebutLoc', 'contenant');

    const progm = this.createObjtMvtBennePgm();
    mouvement['clefProgram'] = '' + (progm['id'] || 0);
    const famille = this.benneChantier['typeContenant'] ? (this.benneChantier['typeContenant'].famille ?
      this.benneChantier['typeContenant'].famille.id : '') : '0';
    const cubage = this.benneChantier['typeContenant'] ? (this.benneChantier['typeContenant'].cubage ?
      this.benneChantier['typeContenant'].cubage.id : '') : '0';
    const article = this.benneChantier['art'] ? '' + this.benneChantier['art'].id : '0';
    tabUpdateBenneChantier = [
      'DBUpdateBenneChantier',
      '' + cubage,
      '' + famille,
      '' + this.common.user[0],
      article,
      '' + (this.benneChantier['id'] || 0),
      '1',
      '0',
      '' + (this.newprest['program'] ? true : false), // true si program checked || false
      this.benneChantier['isGroupeArticle'] ? '1' : '0',
      this.benneChantier['isGroupeBenne'] ? '1' : '0',
      '' + this.newprest['chantier'].id,
      this.newprest['infos'] || '', // tabUpdateBenneChantier[12]
      '' + (this.newprest['contenant'].isLocation || false), // isLocation  // tabUpdateBenneChantier[13]
      this.newprest['contenant'].dateDebutLoc ? moment(this.newprest['contenant'].dateDebutLoc).format('YYYY-MM-DD') : '2000-01-01', // date debut loc, tabUpdateBenneChantier[14]
      '0',
      '0',
      '0',
      '0'
    ];


    const beneData = {
      'id': this.benneChantier['id'],
      'nomclass': 'BenneData',
      'infoFact': this.benneChantier['infoFact'],
      'art': this.benneChantier['art'],
      'isGroupeBenne': this.benneChantier['isGroupeBenne'] || false,
      'isGroupeArticle': this.benneChantier['isGroupeArticle'] || false,
      'listBennes': this.benneChantier['listBennes'] || [],
      'listArticles': this.benneChantier['listArticles'] || [],
      'contrat': this.newprest['numContrat'] ? 'true' : 'false',
      'numContrat': this.newprest['numContrat'] || '',
      'infos': this.newprest['infosbenneChantiers'] || '',
      'dateDebutLoc': this.benneChantier['dateDebutLoc'] ? moment(this.benneChantier['dateDebutLoc']).format('DD/MM/YYYY') : '01/01/2000',
      'typeLocation': this.benneChantier['typeLocation'] || 1,
      'isLocImmediat': this.benneChantier['isLocImmediat'] || false,
      'isLocJour': this.benneChantier['isLocJour'] || false,
      'isTarifLoc': this.benneChantier['isTarifLoc'] || false,
      'tarifLoc': this.benneChantier['tarifLoc'] || 0,
      'nbrRotTarifLoc': this.benneChantier['nbrRotTarifLoc'] || 0,
      'nbrRotGratuite': this.benneChantier['nbrRotGratuite'] || 0,
      'isTarifRot': this.benneChantier['isTarifRot'] || false,
      'tarifRot': this.benneChantier['tarifRot'] || 0,
      'commentairesFact': this.benneChantier['commentairesFact'] || '',
      'qteContenant': this.benneChantier['qteContenant'] || 1,
      'benneClient': this.benneChantier['benneClient'],
      'mailContenant': this.benneChantier['mailContenant'] || '',
    };
    const param = {
      'servlet': 'DBUpdateBenneChantier',
      'module': 'Ecobennes',
      'type': 'liste',
      'compression': 'true',
      'data': [
        tabUpdateBenneChantier,
        this.benneChantier['listArticles'] || [], // groupe article
        this.benneChantier['listBennes'] || [],
        this.newprest['chantier'],
        this.newprest['client'],
        mouvement, // mouvement
        beneData, // benne.getBenneData()
        {
          'typeParam': 'int',
          'valeur': this.common.user[2]
        },
        this.newprest['program'] ? progm : 'null', // this.newprest['program'] ? MouvementBenneProgramme : 'null'
        // 'false'
        {
          'typeParam': 'boolean',
          'valeur': false
        }
      ]
    };

    return this.common.post('', { param: param }).then(datas => {
      if (!isEdit) {
        if (!this.info['mouvCourant']) {
          this.createMouv(datas);
        } else {
          this.updateMouv(datas);
        }
      } else {
        return datas;
      }
    }).catch(err => {
      this.isClicked = false;
      return { "message": err };
    });
  }

  createMouv(data?) {
    const mouvement = this.createObjMvt(data);
    mouvement['listeClesBennesDuGroupe'] = data ? (data.data || []) : [];
    mouvement['listeMouvementsSupplementaires'] = mouvement['listeMouvementsSupplementaires'] || [];
    mouvement['listeMouvementsSupplementaires'].forEach(elt => {
      elt.listeClesBennesDuGroupe = data ? (data.data || []) : [];
    });
    mouvement['user'] = '' + this.common.user[0];
    const param = {
      'servlet': 'DBCreationMouv',
      'module': 'Recylog',
      'type': 'liste',
      'compression': 'false',
      'data': [
        ['DBCreationMouv'],
        mouvement,
        {
          'typeParam': 'int',
          'valeur': this.common.user[2]
        }
      ]
    };

    return this.common.post('', { param: param }).then(datas => {
      if (!datas.message) {
        if (this.isDmdEcoGED) {
          this.showalert.emit(datas.data);
        }
        this.updateClientChantier();
      } else {
        this.isClicked = false;
        this.error = datas.message;
        this.common.openModal(this.modalService, this.msgFormat);
      }

    }).catch(err => {
      this.isClicked = false;
    });
  }

  updateMouv(data?, isTournee?) { // update Mouvement
    const mouvement = this.createObjMvt(data);
    mouvement['listeClesBennesDuGroupe'] = data ? (data.data || []) : [];
    mouvement['listeMouvementsSupplementaires'] = mouvement['listeMouvementsSupplementaires'] || [];
    mouvement['listeMouvementsSupplementaires'].forEach(elt => {
      elt.listeClesBennesDuGroupe = data ? (data.data || []) : [];
    });
    mouvement['bon'] = this.info['bon'];
    mouvement['bon'].numBonManuel = this.info['mouvPrincipal'] ? this.info['mouvPrincipal'][36] : (this.newprest['numBonManuel'] || '');
    mouvement['bon'].numBSDD = this.info['mouvPrincipal'] ? this.info['mouvPrincipal'][24] : this.newprest['numBSDD'] || '';
    mouvement['facturation'] = this.info['mouvPrincipal'] ? this.info['mouvPrincipal'][5] : this.newprest['acompte'] || '0';
    mouvement['user'] = '' + this.common.user[0];
    if (isTournee) {
      mouvement['tournee'] = this.newprest['tournee'];
    }

    const camion = (this.info['mouvPrincipal'] ? this.info['mouvPrincipal'][20] : '0')
    // debug 114733
    mouvement['camion'] = camion ? { id: camion || 0 } : { id: 0 }
    // if (this.societe['choixCamionCreationMouv']) {
    // if (this.mouvement && this.mouvement['id']) {
    //    mouvement['camion'] = this.mouvement['camion'] ? { id: this.mouvement['camion'].id || 0 } : { id: 0 }
    // }
    // }
    const user = this.common.local.getObject('userDetail').nom;

    const param = {
      'servlet': 'DBUpdateMouv',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        MOUVEMENT: mouvement,
        NOM_USER: '' + user,
        MOUV_PROGRAMME: {
          'typeParam': 'boolean',
          'valeur': this.updateAll // false // si oui || false
        },
        USER: {
          'typeParam': 'int',
          'valeur': this.common.user[0]
        },
        SITE: {
          'typeParam': 'int',
          'valeur': this.common.user[2]
        },
        CLEF_BON: {
          'typeParam': 'int',
          'valeur': this.info['bonSelected'] ? (this.info['bonSelected'].id || 0) : 0
        }
      }
    };

    return this.common.post('', { param: param }).then(datas => {
      if (!datas.message) {
        this.updateClientChantier();
      } else {
        this.isClicked = false;
        this.error = datas.message;
        this.common.openModal(this.modalService, this.msgFormat);
      }
    }).catch(err => {
      this.isClicked = false;
    });
  }

  modifContentMvt() {
    this.info['mouvCourant'][1] = this.info['mouvCourant'][1].filter(elt => elt[4] !== this.info['mouvPrincipal'][0]);
    this.info['mouvCourant'][4] = this.info['mouvCourant'][4].filter(elt => elt.id !== parseInt(this.info['mouvPrincipal'][0], 10));
    this.info['mouvCourant'][1].forEach((elt, index) => {
      let mouv;

      this.info['mouvCourant'][4].forEach(mvt => {
        if ('' + mvt.id === elt[4]) {
          mouv = mvt;
        }
      });
      const datemax = mouv && mouv['dateMax'] ? moment(mouv['dateMax'], 'DD/MM/YYYY HH:mm:ss').format('YYYY-MM-DD') : '2000-01-01';

      this.listeMouvSupp[index] = [
        elt[0], // date
        elt[1], // heure
        elt[2], // operation
        elt[3], // chauffeur
        elt[4], // clef mvt
        elt[5], // clef bon
        elt[6], // numbon
        elt[7] === '0' ? 'false' : 'true', // au plustard
        elt[8], // date dmd => date de jour
        elt[9], // exutoire => exutoire existant
        elt[10], // site prest
        elt[11], // info mvt
        '' + this.newprest['isImportant'], // important => false
        elt[13], // hors pgm  => true
        elt[14], // contrat => ''
        elt[15], // durée => ''
        elt[16], // site CA => site encours
        elt[17], // type dmd => type dmd existant
        elt[18], // acompte
        elt[19], // info fact
        elt[20], // bsdd
        elt[21], // clef camion => 0
        elt[22], // reception chantier => 'false'
        elt[23], // date reception chantier => 2000-01.01
        elt[24], // heure reception chantier => ''
        elt[25], // clef camion chantier => '0'
        elt[26], // clef chauffeur chantier => '0'
        elt[27], // position planning chantier => '0'
        elt[29], // bon manuel index 28
        elt[30], // periode index 29 => '0'
        datemax, // date max => cf movtcourant index 4 mvt.dateMax : yyyy-mm-dd index 30 => date mvt
        mouv ? mouv['bon'].axeAnalytiqueLignePrestation || '' : '', // axeAnalytiqueLignePrestation => ''
        mouv ? mouv['bon'].axeAnalytiqueLigneArticle || '' : '', // axeAnalytiqueLigneArticle => ''
      ];

      mouv['dateEnlevement'] = elt[0];
      mouv['heure'] = elt[1];
      mouv['operation'] = elt[2];
      mouv['chauffeur'] = {
        'id': elt[3]
      };
      mouv['bon'].numBSDD = elt[20];
      mouv['bon'].numBonManuel = elt[29];
      mouv['auPlusTard'] = elt[7] === '0' ? false : true;
      mouv['dateDemande'] = elt[8];
      mouv['exutoire'] = {
        id: elt[9]
      };
      mouv['siteExploitation'] = {
        id: elt[10]
      };
      mouv['infoSupp'] = elt[11];
      mouv['important'] = this.newprest['isImportant'];
      mouv['horsProgram'] = elt[13] === '0' || elt[13] === 'false' ? false : true;
      mouv['contrat'] = {
        id: elt[14]
      };
      mouv['duree'] = elt[15];
      mouv['clefSiteCA'] = elt[16];
      mouv['typeDemande'] = {
        id: elt[17]
      };
      mouv['facturation'] = mouv['isFact'] ? elt[18] : '0.00';
      mouv['infoFact'] = elt[19];
      mouv['camion'] = {
        id: elt[21]
      };

      mouv['receptionChantier'] = elt[22] === '0' || elt[22] === 'false' ? false : true;
      mouv['dateReception'] = elt[22] === '0' || elt[22] === 'false' ? '2000-01-01' : elt[23];
      mouv['heureReception'] = elt[22] === '0' || elt[22] === 'false' ? '' : elt[24];
      mouv['camionChantier'] = {
        id: elt[25]
      };
      mouv['chauffeurChantier'] = {
        id: elt[26]
      };
      mouv['positionPlanningChantier'] = elt[27];
      mouv['listeClesBennesDuGroupe'] = mouv['listeClesBennesDuGroupe'] || [];
    });

  }

  updateListeMvt(data?) {
    const heure = this.hourMvt();
    const sitePrest = this.isShowSite ? (this.newprest['sitePrest'] ? this.newprest['sitePrest'].id
      : this.common.user[2]) : this.common.user[2];
    if (this.info && this.info['mouvPrincipal'] && this.info['mouvCourant']) {
      if (this.edit) {
        if (parseInt(this.info['bonSelected'].id, 10) === parseInt(this.info['mouvPrincipal'][16], 10)) {
          this.info['mouvPrincipal'][4] = heure;
          this.info['mouvPrincipal'][5] = '' + (this.newprest['acompte'] || '');
          this.info['mouvPrincipal'][3] = moment(this.newprest['dateStart']).format('YYYY-MM-DD');
          this.info['mouvPrincipal'][11] = '' + (this.newprest['typeOperation'] ? this.newprest['typeOperation'].id : '');
          this.info['mouvPrincipal'][28] = (this.newprest['infoFact'] || '');
          this.info['mouvPrincipal'][10] = (this.newprest['infoNextMouv'] || '');
          this.info['mouvPrincipal'][36] = (this.newprest['numBonManuel'] || '');
          this.info['mouvPrincipal'][24] = (this.newprest['numBSDD'] || '');
          this.info['mouvPrincipal'][14] = '' + sitePrest;

          console.log('Mouv principal', this.info['mouvPrincipal']);
        } else {
          this.listeMouvSupp.forEach(elt => {
            if (this.info['bonSelected'] && (elt[5] === '' + this.info['bonSelected'].id)) {
              elt[1] = heure;
              elt[18] = '' + (this.newprest['acompte'] || '0.00');
              elt[0] = moment(this.newprest['dateStart']).format('YYYY-MM-DD');
              elt[2] = '' + (this.newprest['typeOperation'] ? this.newprest['typeOperation'].id : '0');
              elt[19] = (this.newprest['infoFact'] || '');
              elt[11] = (this.newprest['infoNextMouv'] || '');
              elt[28] = (this.newprest['numBonManuel'] || '');
              elt[9] = '' + (this.newprest['exutoire'] ? this.newprest['exutoire'].id : 0);
              elt[20] = (this.newprest['numBSDD'] || '');
              elt[12] = '' + this.newprest['isImportant'];
              elt[10] = '' + sitePrest;
              console.log('Edit mouv', elt);
            }
          });
          this.info['mouvCourant'][4].forEach(mouv => {
            if (mouv.bon.id === this.info['bonSelected'].id) {
              mouv['dateEnlevement'] = moment(this.newprest['dateStart']).format('YYYY-MM-DD');
              mouv['heure'] = heure;
              mouv['operation'] = this.newprest['typeOperation'] ? this.newprest['typeOperation'].id : '0';
              mouv['bon'].numBSDD = this.newprest['numBSDD'] || '';
              mouv['bon'].numBonManuel = this.newprest['numBonManuel'] || '';
              mouv['exutoire'] = {
                id: (this.newprest['exutoire'] ? this.newprest['exutoire'].id : 0)
              };
              mouv['important'] = this.newprest['isImportant'];
              mouv['infoSupp'] = this.newprest['infoNextMouv'] || '';
              mouv['facturation'] = this.newprest['acompte'] ? parseFloat(this.newprest['acompte']).toFixed(2) : '0.00';
              mouv['infoFact'] = this.newprest['infoFact'] || '';
              /****todo */
              mouv['clefSitePrest'] = sitePrest;

              mouv['listeClesBennesDuGroupe'] = data ? (data.data || []) : [];
            }
            mouv['listeClesBennesDuGroupe'] = data ? (data.data || []) : [];
          });
        }
      } else {
        let typedmd = '0';
        if (this.info['mouvPrincipalObj']) {
          typedmd = this.info['mouvPrincipalObj'].typeDemande ? this.info['mouvPrincipalObj'].typeDemande.id : '0';
        }
        const mouvSupp = [
          moment(this.newprest['dateStart']).format('YYYY-MM-DD'), // date
          heure || '00h00', // heure
          '' + (this.newprest['typeOperation'] ? this.newprest['typeOperation'].id : '0'), // operation
          '0', // chauffeur
          '0', // clef mvt
          '0', // clef bon
          '0', // numbon
          'false', // au plustard
          moment().format('YYYY-MM-DD'), // date dmd => date de jour
          '' + (this.newprest['exutoire'] ? this.newprest['exutoire'].id : 0), // exutoire => exutoire existant
          '' + sitePrest, // site
          this.newprest['infoNextMouv'] || '', // info mvt
          '' + this.newprest['isImportant'], // important => false
          'true', // hors pgm  => true
          '0', // contrat => ''
          '0', // durée => ''createObjMvt
          '' + this.common.user[2], // site CA => site encours
          '' + typedmd, // type dmd => type dmd existant
          this.newprest['acompte'] ? parseFloat(this.newprest['acompte']).toFixed(2) : '0.00', // acompte
          this.newprest['infoFact'] || '', // info fact
          this.newprest['numBSDD'] || '', // bsdd
          '0', // clef camion => 0
          'false', // reception chantier => 'false'
          '2000-01-01', // date reception chantier => 2000-01.01
          '', // heure reception chantier => ''
          '0', // clef camion chantier => '0'
          '0', // clef chauffeur chantier => '0'
          '0', // position planning chantier => '0'
          this.newprest['numBonManuel'] || '', // bon manuel index 28
          '0', // periode index 29 => '0'
          moment(this.newprest['dateStart']).format('YYYY-MM-DD'), // dateMax
          '', // axeAnalytiqueLignePrestation => ''
          '', // axeAnalytiqueLigneArticle => ''
        ];

        const mouv = {
          'id': 0,
        };
        mouv['dateEnlevement'] = moment(this.newprest['dateStart']).format('YYYY-MM-DD');
        mouv['heure'] = heure || '00h00';
        mouv['operation'] = '' + (this.newprest['typeOperation'] ? this.newprest['typeOperation'].id : '0');
        mouv['chauffeur'] = {
          'id': '0'
        };
        mouv['bon'] = {
          'id': 0,
          'numBSDD': this.newprest['numBSDD'] || '',
          'numBonManuel': this.newprest['numBonManuel'] || '',
        };
        mouv['auPlusTard'] = false;
        mouv['dateDemande'] = this.newprest['numBSDD'] || '';
        mouv['exutoire'] = {
          id: (this.newprest['exutoire'] ? this.newprest['exutoire'].id : 0)
        };
        mouv['siteExploitation'] = {
          id: this.common.user[2]
        };
        mouv['infoSupp'] = this.newprest['infoNextMouv'] || '';
        mouv['important'] = this.newprest['isImportant'];
        mouv['horsProgram'] = true;
        mouv['contrat'] = {
          id: 0
        };
        mouv['duree'] = '0';
        mouv['clefSiteCA'] = this.common.user[2];
        mouv['typeDemande'] = {
          id: typedmd
        };
        mouv['facturation'] = this.newprest['acompte'] ? parseFloat(this.newprest['acompte']).toFixed(2) : '0.00';
        mouv['infoFact'] = this.newprest['infoFact'] || '';
        mouv['camion'] = {
          id: '0'
        };

        mouv['receptionChantier'] = false;
        mouv['dateReception'] = '2000-01-01';
        mouv['heureReception'] = '';
        mouv['camionChantier'] = {
          id: '0'
        };
        mouv['chauffeurChantier'] = {
          id: '0'
        };
        mouv['positionPlanningChantier'] = '0';
        mouv['periode'] = {
          id: '0'
        };
        // mouv['listeClesBennesDuGroupe'] = [];
        mouv['listeClesBennesDuGroupe'] = data ? (data.data || []) : [];
        let existe, existeSupp = false;

        this.listeMouvSupp.forEach(elt => {
          if (elt[4] === '0') {
            existeSupp = true;
          }
        });
        if (!existeSupp) {
          this.listeMouvSupp[this.listeMouvSupp.length] = mouvSupp;
        }

        this.info['mouvCourant'][4].forEach(elt => {
          elt['listeClesBennesDuGroupe'] = data ? (data.data || []) : [];
          if (elt.id === 0) {
            existe = true;
            elt = mouv;
          }
        });
        if (!existe) {
          this.info['mouvCourant'][4].push(mouv);
        }

        this.info['mouvCourant'][4] = this.info['mouvCourant'][4].filter(elt => '' + elt.id !== this.info['mouvPrincipal'][0]);
      }
    }
  }

  createObjMvt(data?) {
    /***Modif à faire demain */
    const heure = this.hourMvt();
    const progm = this.createObjtMvtBennePgm();
    // si xMouv alors mouv.listMouvSupp index 1 @ mouvcourant atao anaty mouv
    // listeMouvementsSupplementaires index 4 @ mouvcourant atao anaty mouv

    this.updateListeMvt(data);
    const sitePrest = this.isShowSite ? (this.newprest['sitePrest'] ? this.newprest['sitePrest'].id
      : this.common.user[2]) : this.common.user[2];
    const mouvement = {
      'dateDemande': moment().format('YYYY-MM-DD'),
      'dateEnlevement': this.info['mouvPrincipal'] ? this.info['mouvPrincipal'][3]
        : moment(this.newprest['dateStart']).format('YYYY-MM-DD'),
      'heure': this.info['mouvPrincipal'] ? this.info['mouvPrincipal'][4] : heure,
      'clefBenneChantiers': '' + (this.benneChantier['id'] || 0),
      'clefClient': '' + (this.newprest['client'] ? this.newprest['client'].id : '0'),
      'clefChauffeur': '' + (this.info['mouvPrincipal'] ? this.info['mouvPrincipal'][7] : '0'), // clef chauffeur => debug pnt 102797
      'operation': this.info['mouvPrincipal'] ? this.info['mouvPrincipal'][11]
        : '' + (this.newprest['typeOperation'] ? this.newprest['typeOperation'].id : '0'), // choix operation
      'clefExutoire': '' + (this.newprest['exutoire'] ? (this.newprest['exutoire'].id || '0') : '0'),
      'clefSitePrest': this.info['mouvPrincipal'] ? sitePrest : '' + this.common.user[2],
      'clefSiteCA': '' + this.common.user[2],
      'infoFact': this.info['mouvPrincipal'] ? this.info['mouvPrincipal'][28] : (this.newprest['infoFact'] || ''),
      'infoSup': this.info['mouvPrincipal'] ? this.info['mouvPrincipal'][10] : (this.newprest['infoNextMouv'] || ''),
      'listMouvSupp': this.info['mouvCourant'] ? this.listeMouvSupp : [],
      'listeMouvementsSupplementaires': this.info['mouvCourant'] ? this.info['mouvCourant'][4] : [],
      'bon': {
        'numBonManuel': this.info['mouvPrincipal'] ? this.info['mouvPrincipal'][36] : this.newprest['numBonManuel'] || '',
        'numBSDD': this.info['mouvPrincipal'] ? this.info['mouvPrincipal'][24] : this.newprest['numBSDD'] || '',
      },
      'clefProgram': this.newprest['program'] ? ('' + (progm['id'])) : '0', // MouvementBenneProgramme.id || '0'
      'isProgram': this.newprest['program'],
      // 'horsProgram': this.newprest['program'] ? false : true,
      'listeClesBennesDuGroupe': data ? (data.data || []) : [],
      'user': '' + this.common.user[0],
      'facturation': this.info['mouvPrincipal'] ? this.info['mouvPrincipal'][5] : this.newprest['acompte'],
      'important': this.newprest['isImportant'],
      'nomclass': 'Mouvement'
    };

    if (this.newprest['program']) {
      mouvement['isProgram'] = true;
      mouvement['typeProg'] = progm['typeOperation'];
      mouvement['freqProg'] = progm['frequence'];
      mouvement['listDateProg'] = progm['listJours'];
    }

    return mouvement;
  }

  testOperationValidation(dt, isGroupe?) {
    const momentDate = moment(this.newprest['dateStart']);
    const operation = [];
    operation.push(...this.listOperationBenne, ...this.listOperationNew);
    dt.LISTE_MOUV = dt.LISTE_MOUV || [];
    const existeMouvRetrait = dt.LISTE_MOUV.filter(elt => elt.operation === '1');
    if (existeMouvRetrait && existeMouvRetrait.length) {
      // 1
      const retrait = existeMouvRetrait[0] || {};
      const momentRetrait = moment(retrait.dateEnlevement, 'YYYY-MM-DD');
      if (momentDate.isAfter(momentRetrait)) {
        this.isRetrait = true;
        this.isRetrait = true;
        const date = moment(retrait.dateEnlevement, 'YYYY-MM-DD').format('DD/MM/YYYY');
        const numbon = retrait.bon ? retrait.bon.numBon || '' : '';
        this.error = `Il existe déjà un retrait sur ${isGroupe ? 'ce groupe de' :
          'cette'} benne le ${date} sur le bon ${numbon}.`;
        this.common.openModal(this.modalService, this.msg);
      } else {
        const mouvSupp = dt.LISTE_MOUV || [];
        const listMouv = mouvSupp.filter(elt => moment(elt.dateEnlevement, 'YYYY-MM-DD').isAfter(momentDate) && elt.operation === '0');
        if (listMouv && listMouv.length) {
          if (!this.newprest['typeOperation'] || (this.newprest['typeOperation'] && this.newprest['typeOperation'] === 0)) {
            this.updateBenneChantier(true).then(data => {
              if (!data || !data.message) {
                this.updateMouv(data);
              }
            });
          } else {
            const mvtD = listMouv[0] || {};
            this.isRetrait = true;
            let ope = '';
            operation.forEach(elt => {
              if (elt.id === parseInt(mvtD['operation'], 10)) {
                ope = elt.libelleObjetEntite;
              }
            });
            const date = moment(mvtD.dateEnlevement, 'YYYY-MM-DD').format('DD/MM/YYYY');
            const numbon = mvtD.bon ? mvtD.bon.numBon || '' : '';
            this.error = `Il existe déjà un mouvement de  ${ope} sur ${isGroupe ? 'ce groupe de' :
              'cette'} de benne le ${date} sur le bon ${numbon}.`;
            this.common.openModal(this.modalService, this.msg);
          }
        } else {
          this.updateBenneChantier(true).then(data => {
            if (!data || !data.message) {
              this.updateMouv(data);
            }
          });
        }
      }
    } else {
      // 2
      const mouvSupp = dt.LISTE_MOUV || [];
      const listMouv = mouvSupp.filter(elt => moment(elt.dateEnlevement, 'YYYY-MM-DD').isAfter(momentDate) && elt.operation === '0');
      if (listMouv && listMouv.length) {
        if (!this.newprest['typeOperation'] || (this.newprest['typeOperation'] && this.newprest['typeOperation'] === 0)) {
          this.updateBenneChantier(true).then(data => {
            if (!data || !data.message) {
              this.updateMouv(data);
            }
          });
        } else {
          const mvtD = listMouv[0] || {};
          this.isRetrait = true;
          let ope = '';
          operation.forEach(elt => {
            if (elt.id === parseInt(mvtD['operation'], 10)) {
              ope = elt.libelleObjetEntite;
            }
          });
          const date = moment(mvtD.dateEnlevement, 'YYYY-MM-DD').format('DD/MM/YYYY');
          const numbon = mvtD.bon ? mvtD.bon.numBon || '' : '';
          this.error = `Il existe déjà un mouvement de  ${ope} sur ${isGroupe ? 'ce groupe de' :
            'cette'} de benne le ${date} sur le bon ${numbon}.`;
          this.common.openModal(this.modalService, this.msg);
        }
      } else {
        this.updateBenneChantier(true).then(data => {
          if (!data || !data.message) {
            this.updateMouv(data);
          }
        });
      }
    }
  }

  validerUpdateContenant() {
    this.benneChantier = this.newprest['contenant'];
    this.benneChantier['qteContenant'] = this.benneChantier['qteContenant'] ? parseInt(this.benneChantier['qteContenant'], 10) : 1;
    const isClient = this.newprest['client'] && this.newprest['client'].id ? true : false;
    const isChantier = this.newprest['chantier'] && this.newprest['chantier'].id ? true : false;
    const isArticle = this.benneChantier['isGroupeArticle'] ? true : (this.benneChantier['art'] && this.benneChantier['art'].id ? true : false);
    const isExutoire = this.newprest['exutoire'] && this.newprest['exutoire'].id ? true : false;
    const isTypecont = this.benneChantier['typeContenant'] && this.benneChantier['typeContenant'].id ? true : false;
    const isGoupe = this.benneChantier['isGroupeBenne'] || false;
    const listBennes = this.benneChantier['listBennes'] || [];
    // if (this.benneChantier['listArticle']) {
    //   this.benneChantier['listArticle'].forEach(elt => elt.nomclass = 'Article');
    // }

    const dateStart = moment(this.newprest['dateStart']).format('YYYY-MM-DD');
    if (!this.isValidDate(dateStart)) {
      this.error = 'La date n\'est pas valide.';
      this.isClicked = false;
      this.common.openModal(this.modalService, this.msg);
      return;
    }

    if (this.benneChantier['isGroupeArticle'] && !this.benneChantier['listArticle'].length) {
      this.error = 'Votre groupe d\'article doit comporter au moins un article.';
      this.isClicked = false;
      this.common.openModal(this.modalService, this.msg);
      return;
    }

    if (this.benneChantier['listArticle']) {
      this.benneChantier['listArticles'] = [];
      this.benneChantier['listArticle'].forEach(elt => {
        const art = Object.assign({}, elt.art);
        art.exu = Object.assign({}, elt.exutoire);
        art.nomclass = 'Article';
        this.benneChantier['listArticles'].push(art);
      });
    }

    if (this.benneChantier['listBennes']) {
      this.benneChantier['listBennes'].forEach(elt => {
        if (elt.id < 0) {
          elt.id = 0;
        }
        elt.nomclass = 'BenneData';
        elt.operation = elt.operationBenne ? (elt.operationBenne['id'] || '2') : '2';
        elt.operationBenne = {
          id: elt.operationBenne ? (elt.operationBenne['id'] || '2') : '2'
        };
        // elt.nomclass = 'BenneData';
        // elt.operationBenne = {
        //   id: '2'
        // };
      });
    }


    if (!this.isClicked) {
      this.isClicked = true;
      if (isClient && isChantier && isArticle && isExutoire && isTypecont && !isGoupe) {
        if (!this.isVidage) {
          this.benneChantier = this.newprest['contenant'];
          this.checkRetraitBenne().then(datas => {
            const dt = datas.data || {};
            const momentDate = moment(this.newprest['dateStart']);
            this.testOperationValidation(dt);
            // if (dt.id && dt.id !== this.info['bonSelected'].id) {
            //   this.isRetrait = true;
            //   const momentRetrait = moment(dt.date, 'DD/MM/YYYY');
            //   if (momentRetrait.isAfter(momentDate)) {
            //     this.isRetrait = true;
            //     this.error = `Il existe déjà un retrait sur cette benne le ${dt.date} sur le bon ${dt.numBon}.`;
            //     this.common.openModal(this.modalService, this.msg);
            //   } else {
            //     if (this.isRetraitFct()) {
            //       const mouvSupp = this.info['mouvCourant'] ? (this.info['mouvCourant'][4] || []) : [];
            //       const listMouv = mouvSupp.filter(elt => moment(elt.dateEnlevement, 'YYYY-MM-DD').isAfter(momentDate));
            //       console.log('listMouv supp', listMouv)
            //       if (listMouv && listMouv.length) {
            //         const mvtD = listMouv[listMouv.length - 1] || {};
            //         this.isRetrait = true;
            //         let ope = '';
            //         operation.forEach(elt => {
            //           if (elt.id === parseInt(mvtD['operation'], 10)) {
            //             ope = elt.libelleObjetEntite;
            //           }
            //         });
            //         const date = moment(mvtD.dateEnlevement, 'YYYY-MM-DD').format('DD/MM/YYYY');
            //         const numbon = mvtD.bon ? mvtD.bon.numBon || '' : '';
            //         this.error = `Il existe déjà un mouvement de ${ope} sur cette benne le ${date} sur le bon ${numbon}.`;
            //         this.common.openModal(this.modalService, this.msg);
            //       } else {
            //         this.updateBenneChantier(true).then(data => {
            //           this.updateMouv(data);
            //         });
            //       }
            //     } else {
            //       this.updateBenneChantier(true).then(data => {
            //         this.updateMouv(data);
            //       });
            //     }
            //   }
            // } else {
            //   if (dt.id && dt.id === this.info['bonSelected'].id) {
            //     const mouvSupp = this.info['mouvCourant'] ? (this.info['mouvCourant'][4] || []) : [];
            //     const listMouv = mouvSupp.filter(elt => moment(elt.dateEnlevement, 'YYYY-MM-DD').isAfter(momentDate));
            //     console.log('listMouv supp', listMouv)
            //     if (listMouv && listMouv.length) {
            //       const mvtD = listMouv[listMouv.length - 1] || {};
            //       this.isRetrait = true;
            //       let ope = '';
            //       operation.forEach(elt => {
            //         if (elt.id === parseInt(mvtD['operation'], 10)) {
            //           ope = elt.libelleObjetEntite;
            //         }
            //       });
            //       const date = moment(mvtD.dateEnlevement, 'YYYY-MM-DD').format('DD/MM/YYYY');
            //       const numbon = mvtD.bon ? mvtD.bon.numBon || '' : '';
            //       this.error = `Il existe déjà un mouvement de ${ope} sur cette benne le ${date} sur le bon ${numbon}.`;
            //       this.common.openModal(this.modalService, this.msg);
            //     } else {
            //       this.updateBenneChantier(true).then(data => {
            //         this.updateMouv(data);
            //       });
            //     }
            //   } else {
            //     this.updateBenneChantier(true).then(data => {
            //       this.updateMouv(data);
            //     });
            //   }
            // }
          }).catch(err => {
            this.isClicked = false;
          });
        } else {
          this.updateParking();
        }
      } else {
        if (!this.newprest['tournee'] && isGoupe && isClient && isChantier && isExutoire && isTypecont) {
          if (listBennes.length) {
            if (!this.isVidage) {
              this.benneChantier = this.newprest['contenant'];
              const momentDate = moment(this.newprest['dateStart']);
              this.checkRetraitBenne().then(datas => {
                const dt = datas.data || {};
                this.testOperationValidation(dt, true);
              }).catch(err => {
                this.isClicked = false;
              });
            } else {
              this.updateParking();
            }
          } else {
            this.isClicked = false;
            this.error = `Votre groupe de contenant doit comporter au moins un contenant`;
            this.common.openModal(this.modalService, this.msg);
          }
        } else {
          if (this.newprest['tournee']) {
            if (!this.isVidage) {
              this.editMvtTourne();
              // this.updateMouv([], true);
              /*this.checkRetraitBenne().then(datas => {
                const dt = datas.data || {};
                if (dt.id && dt.id !== this.info['bonSelected'].id) {
                  this.isRetrait = true;
                  this.error = `Il existe déjà un retrait sur cette tournée le ${dt.date} sur le bon ${dt.numBon}.`;
                  this.common.openModal(this.modalService, this.msg);
                } else {
                  this.updateBenneChantier(true).then(data => {
                    this.updateMouv(data);
                  });
                }
              });*/
            } else {
              this.updateParking();
            }
          } else {
            this.isClicked = false;
            this.error = `Veuillez renseigner tous les champs obligatoires. (client, chantier, article, type de contenant et exutoire)`;
            this.common.openModal(this.modalService, this.msg);
          }
        }
      }
    }

  }

  updateParking() {
    // todo : updateParking
    const heure = this.hourMvt();
    const sitePrest = this.isShowSite ? (this.newprest['sitePrest'] ? this.newprest['sitePrest'].id
      : this.common.user[2]) : this.common.user[2];
    const mouvement = {
      'dateDemande': moment().format('YYYY-MM-DD'),
      'dateEnlevement': moment(this.newprest['dateStart']).format('YYYY-MM-DD'),
      'heure': heure,
      'clefBenneChantiers': '' + (this.benneChantier['id'] || 0),
      'clefClient': '' + (this.newprest['client'] ? this.newprest['client'].id : '0'),
      'clefChauffeur': '' + (this.info['mouvPrincipal'] ? this.info['mouvPrincipal'][7] : '0'), // clef chauffeur => debug pnt 102797
      'operation': (this.newprest['typeOperation'] ? this.newprest['typeOperation'].id : '0'), // choix operation
      'clefExutoire': '' + (this.newprest['exutoire'] ? this.newprest['exutoire'].id : '0'),
      'clefSitePrest': '' + sitePrest,
      'clefSiteCA': '' + this.common.user[2],
      'infoFact': (this.newprest['infoFact'] || ''),
      'infoSup': (this.newprest['infoNextMouv'] || ''),
      'listMouvSupp': this.listeMouvSupp || [],
      'listeMouvementsSupplementaires': [],
      'clefProgram': '0',
      'listeClesBennesDuGroupe': this.mouvement['listeClesBennesDuGroupe'] || [],
      'facturation': this.newprest['acompte'],
      'important': this.newprest['isImportant'],
      'nomclass': 'Mouvement'
    };
    mouvement['bon'] = this.info['bon'];
    mouvement['bon'].numBonManuel = (this.newprest['numBonManuel'] || '');
    mouvement['bon'].numBSDD = this.newprest['numBSDD'] || '';
    mouvement['facturation'] = this.newprest['acompte'] || '0';
    mouvement['user'] = '' + this.common.user[0];
    mouvement['infoFact'] = (this.newprest['infoFact'] || '');
    mouvement['infoSup'] = (this.newprest['infoNextMouv'] || '');
    mouvement['id'] = this.mouvement['id'];

    mouvement['benne'] = {
      'nomclass': 'BenneData',
      'id': this.mouvement['benne'].id || 0,
      'infoFact': this.benneChantier['infoFact'],
      'art': this.benneChantier['art'],
      'isGroupeBenne': this.benneChantier['isGroupeBenne'] || false,
      'isGroupeArticle': this.benneChantier['isGroupeArticle'] || false,
      'listBennes': this.benneChantier['listBennes'] || [],
      'listArticles': this.benneChantier['listArticles'] || [],
      'contrat': this.newprest['numContrat'] ? 'true' : 'false',
      'numContrat': this.newprest['numContrat'] || '',
      'infos': this.newprest['infos'] || '',
      'typeContenant': this.benneChantier['typeContenant'],
      'qteContenant': this.benneChantier['qteContenant'] || 1,
      'benneClient': this.benneChantier['benneClient'],
      'mailContenant': this.benneChantier['mailContenant'] || '',
      'dateDebutLoc': this.benneChantier['dateDebutLoc'] ? moment(this.benneChantier['dateDebutLoc']).format('DD/MM/YYYY') : '01/01/2000',
      // point: 115801
      'typeLocation': this.benneChantier['typeLocation'] || 1,
      'isLocImmediat': this.benneChantier['isLocImmediat'] || false,
      'isLocJour': this.benneChantier['isLocJour'] || false,
      'isTarifLoc': this.benneChantier['isTarifLoc'] || false,
      'tarifLoc': this.benneChantier['tarifLoc'] || 0,
      'nbrRotTarifLoc': this.benneChantier['nbrRotTarifLoc'] || 0,
      'nbrRotGratuite': this.benneChantier['nbrRotGratuite'] || 0,
      'isTarifRot': this.benneChantier['isTarifRot'] || false,
      'tarifRot': this.benneChantier['tarifRot'] || 0,
      'commentairesFact': this.benneChantier['commentairesFact'] || '',
    };

    const param = {
      'servlet': 'DBGestionMouvementParking',
      'module': 'Ecobennes',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 1
        },
        'MOUVEMENT': mouvement,
        'USER': {
          'typeParam': 'int',
          'valeur': this.common.user[0]
        },
        'SITE': {
          'typeParam': 'int',
          'valeur': this.common.user[2]
        }
      }
    };
    return this.common.post('', { param: param }).then(datas => {
      if (this.isModifDateVidage) {
        this.common.openModal(this.modalService, this.changedate);
      } else {
        this.closeFunction();
      }
    }).catch(err => {
      this.isClicked = false;
    });
  }


  updateDateWeek() {
    const date = moment(this.newprest['dateStart']).format('YYYY-MM-DD');
    const heure = this.newprest['hour'] + ':' + this.newprest['min'];
    const mouv = this.mouvement;
    const param = {
      'servlet': 'DBUpdateDateMouv',
      'module': 'Ecobennes',
      'type': 'tableau',
      'compression': 'false',
      'data': ['DBUpdateDateMouv', date, '' + mouv.id, '' + this.common.user[0],
        mouv.parking ? '' + mouv.parking.id : '0', heure, 'false', this.raisonReport]
    };
    this.common.closeModal();
    return this.common.post('', { param: param }).then(datas => {
      this.raisonReport = '';
      this.updateClientChantier();
    }).catch(err => {
      this.isClicked = false;
    });
  }


  testerImprimerBon() {
    if (this.isImpressionSansChauffeur()) {
      this.afficherChoixFormatPerso();
    }
  }

  afficherChoixFormatPerso() {
    const ctrl = this;
    GestionFormat.getFormatperso(ConstanteEcorec.TYPE_FORMAT_PARAMETRABLE_BON_BENNES, this.common).then(datasFormat => {
      if (datasFormat.data && datasFormat.data.length) {
        ctrl.formatPerso = datasFormat.data;
        if (this.formatPerso.length >= 1) {
          this.formatprs = this.formatPerso[0];
          // open modal
          this.common.openModal(this.modalService, this.format);
        } else {
          // get pdf to print
          // this.formatprs = this.formatPerso[0];
          this.common.openModal(this.modalService, this.format);
        }
      } else {
        if (datasFormat.message) {
          this.alert.error(datasFormat.message);
        }
      }
    });
  }

  imprimerBon() {
    if (!this.formatprs['id']) {
      this.error = 'Veuillez choisir un format.';
      this.common.openModal(this.modalService, this.msgFormat);
      return;
    } else {
      this.common.closeModal()
      const printPesee = 'PRINT_PESEE';
      const listClef = ['' + this.info['mouvement'].id];
      GestionBon.imprimerBonEcoBenneFP(listClef, this.formatprs['id'], printPesee, this.common).then(datasPrint => {
        if (datasPrint.data && datasPrint.data.length) {
          this.common.openFile(datasPrint.data[0]);
        } else {
          if (datasPrint.message) {
            this.alert.error(datasPrint.message);
          }
        }
      });
    }
  }

  isImpressionSansChauffeur() {
    if (!this.info['mouvement'].chauffeur
      && !this.info['mouvement'].camion) {
      return true;
    }

    if (this.info['mouvement'].chauffeur) {
      return true;
    } else {
      this.immatriculationCamionSsChauffeur = this.info['mouvement'].camion.immatriculation;
      this.common.openModal(this.modalService, this.confirmeImpBonSansChauffeur);
    }

    return false;
  }

  initSupprimerBon() {
    this.common.openModal(this.modalService, this.dialogueSuppression);
  }

  supprimerBon() {
    const that = this;
    if (this.raisonSuppression !== '') {
      let mouvid, benneid;
      benneid = this.info['contenant'].id;
      if (this.info && this.info['mouvPrincipal'] && this.info['mouvCourant']) {
        if ('' + this.info['bonSelected'].id === this.info['mouvPrincipal'][16]) {
          mouvid = this.info['mouvPrincipal'][0];
        } else {
          this.listeMouvSupp.forEach(elt => {
            if (elt[5] === '' + this.info['bonSelected'].id) {
              mouvid = elt[4];
            }
          });
        }
      }

      if (this.isVidage) {
        mouvid = this.info['mouvement'] ? this.info['mouvement'].id : '';
      }

      if (this.info['mouvement'] && this.info['tournee']) {
        mouvid = this.info['mouvement'] ? this.info['mouvement'].id : '';
      }

      // console.log(mouvid, this.info['mouvement']);
      GestionBon.supprimerBonEcoBenne(mouvid, benneid, this.raisonSuppression, this.common).then(datasSupp => {
        that.raisonSuppression = '';
        if (datasSupp.data && datasSupp.data.length) {
          if (datasSupp.data[0] === 'KO') {
            that.error = datasSupp.data[1];
            that.common.openModal(that.modalService, that.msg);
          } else {
            that.closeFunction();
          }
        } else {
          if (datasSupp.message) {
            this.alert.error(datasSupp.message);
          }
        }
      });
      this.common.closeModal();
    }
  }

  checkRetraitBenne() {
    const BenneData = this.newprest['contenant'];
    BenneData.nomclass = 'BenneData';
    // const param = {
    //   'servlet': 'DBCheckRetraitBenne',
    //   'module': 'Ecobennes',
    //   'type': 'map',
    //   'compression': 'false',
    //   'data': {
    //     'BENNE_CHANTIER': BenneData
    //   }
    // };

    const param = {
      'servlet': 'DBCheckRetraitBenne',
      'module': 'Ecobennes',
      'type': 'map',
      'compression': 'false',
      'leger': 'true',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 1
        },
        'BENNE_CHANTIER': BenneData,
        'CLEF_BON': {
          'typeParam': 'int',
          'valeur': this.info['bonSelected'] ? (this.info['bonSelected'].id || 0) : 0
        },
        'CLEF_OPERATION': {
          'typeParam': 'int',
          'valeur': this.newprest['typeOperation'] ? (this.newprest['typeOperation'].id || 0) : 0
        },
      }
    };

    return this.common.post('', { param: param });
  }

  getListeSite() {
    const info = this.common.local.getObject('userDetail');
    this.common.post('', {
      param: {
        'servlet': 'DBGetListSiteUser',
        'module': 'Recylog',
        'type': 'map',
        'compression': 'false',
        'data': {
          'NOM_UTILISATEUR': info.login,
          'IS_HOLDING': {
            'typeParam': 'boolean',
            'valeur': '0'
          }
        }
      }
    }).then(datas => {
      this.common.local.setObject('listeSite', datas.data[0]);
      this.listeSite = datas.data[0] || [];
      this.isShowSite = this.listeSite.length > 1 ? true : false;
      console.log(this.listeSite.length);
      this.listeSite.forEach(elt => {
        if (elt.id === this.common.user[2]) {
          this.defaultSite = elt;
        }
      });
    }).catch(error => console.log(error));
  }

  searchSite(event) {
    this.listeSiteCA = [];
    this.listeSite.forEach(elt => {
      elt.libelleObjetEntite = elt.nom;
      this.listeSiteCA.push(elt);
    });
  }

  changeProgram() {
    this.mouvBenneProgramme['typeProgram'] = this.listProgram[0];
    this.mouvBenneProgramme['frequence'] = 1;
    this.mouvBenneProgramme['typeOperation'] = 1;
    this.mouvBenneProgramme['listTtSemaine'] = [];
    this.mouvBenneProgramme['listSemainePaire'] = [];
    this.mouvBenneProgramme['listSemaineImpaire'] = [];
    this.mouvBenneProgramme['listJoursMois'] = [];
    this.mouvBenneProgramme['listJoursMois1'] = [];
    this.mouvBenneProgramme['listJoursMois2'] = [];
    this.mouvBenneProgramme['listJoursMois3'] = [];
    this.mouvBenneProgramme['listJoursMois4'] = [];
    this.mouvBenneProgramme['listJoursMois5'] = [];
    this.mouvBenneProgramme['listJoursDerSemaineMois'] = [];
    if (this.newprest['program']) {
      this.showProgrammation();
    }
  }

  changeDatePgm(event) {
    if (moment(event).isValid()) {
      this.mouvBenneProgramme['dateFin'] = moment(event).format('DD/MM/YYYY');
    } else {
      this.mouvBenneProgramme['dateFin'] = !this.mouvBenneProgramme['datePgm'] || this.mouvBenneProgramme['datePgm'] === '' ?
        '31/12/9999' : moment().format('DD/MM/YYYY');
    }
  }


  openModalConfirme() {
    const societe = this.common.local.getObject('paramSociete') || {};
    if (societe.ecobennesEquipe && this.newprest['program']) {
      this.common.openModal(this.modalService, this.programConfirme);
    } else {
      this.saveMouvement();
    }
  }

  saveMouvement() {
    if (this.newprest['program'] && !this.modifProgram()) {
      this.error = 'Il faut sélectionner au moins un jour.';
      this.common.openModal(this.modalService, this.msg);
      return;
    }

    this.validerUpdateContenant();
  }

  changeFrequence() {
    if (this.mouvBenneProgramme['nbSemainesProgram'] === '2') {
      this.mouvBenneProgramme['frequence'] = 1;
    }
  }

  showJourFerie() {
    this.isJourFerie = !this.isJourFerie;
  }

  saveJourFerier(event) {
    this.mouvBenneProgramme['tableConfigJoursFeries'] = event;
  }

  showSuspension() {
    this.isSuspension = !this.isSuspension;
  }

  saveSuspension(event) {
    this.mouvBenneProgramme['listePeriodesPause'] = event;
  }

  selectContenantForGroup(elem) {
    const listfilter = this.listBenneSelected.filter(elt => parseInt(elt.id, 10) === parseInt(elem.id, 10));
    if (listfilter.length) {
      let index;
      this.listBenneSelected.forEach((elt, idx) => {
        if (parseInt(elt.id, 10) === parseInt(elem.id, 10)) {
          index = idx;
        }
      });
      // const index = list.indexOf('' + 5);
      this.listBenneSelected.splice(index, 1);
      this.listBenneSelected = [...this.listBenneSelected];
    } else {
      this.listBenneSelected.push(elem);
      this.listBenneSelected = [...this.listBenneSelected];
    }

  }


  selectedContenant(elem) {
    this.listBenneSelected = this.listBenneSelected || [];
    const listfilter = this.listBenneSelected.filter(elt => parseInt(elt.id, 10) === parseInt(elem.id, 10));
    return listfilter.length ? true : false;
  }

  setGroupeBenne() {
    if (!this.deposerContenant) {
      if (this.listBenneSelected.length) {
        if (this.newprest['newContenant']) {
          const benneIndex0 = Object.assign({}, this.listBenneSelected[0]);
          benneIndex0.id = 0;
          this.contenantGoupe = benneIndex0;
          this.contenantGoupe['listBennes'] = this.listBenneSelected;
          this.contenantGoupe['isGroupeBenne'] = true;
          this.setValue(this.contenantGoupe, 'newBenne');
        } else {
          this.contenantGoupe = this.newprest['contenant'];
          this.newprest['contenant']['listBennes'] = this.listBenneSelected;
          // this.setValue(this.contenantGoupe, 'contenant');

          if (this.edit) {
            this.showLeft = false;
            this.isModifier = true;
            setTimeout(function () {
              $('#btnvalider').focus();
            }, 500);
          } else {
            this.nextStep();
          }
        }
      }
    } else {
      this.deposerContenant = !this.deposerContenant;
      console.log(this.contenantDepot);
      this.listcontenant = this.listcontenant || [];
      this.contenantDepot['id'] = -1 * this.listcontenant.length
      this.listcontenant.push(this.contenantDepot);
      this.listBenneSelected.push(this.contenantDepot);
      this.listContDepot.push(this.contenantDepot);
      if (this.newprest['newContenant']) {
        const benneIndex0 = Object.assign({}, this.listBenneSelected[0]);
        benneIndex0.id = 0;
        this.contenantGoupe = benneIndex0;
        this.contenantGoupe['listBennes'] = this.listBenneSelected;
        this.contenantGoupe['isGroupeBenne'] = true;
        // this.setValue(this.contenantGoupe, 'newBenne');
      } else {
        this.contenantGoupe = this.newprest['contenant'];
        this.newprest['contenant']['listBennes'] = this.listBenneSelected;
        // this.setValue(this.contenantGoupe, 'contenant');

        // if (this.edit) {
        //   this.showLeft = false;
        //   this.isModifier = true;
        //   setTimeout(function () {
        //     $('#btnvalider').focus();
        //   }, 500);
        // } else {
        //   this.nextStep();
        // }
      }

      setTimeout(function () {
        $('.btn-ok').focus();
      }, 500);
    }
  }

  getTournee(event) {
    const clefMvt = this.info['mouvement'] ? this.info['mouvement'].id : 0
    const param = {
      'servlet': 'DBGestionTournee',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'true',
      'leger': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 4
        },
        'CLEF_SITE': {
          'typeParam': 'int',
          'valeur': this.common.user[2]
        },
        'OPTIMISATIONS': {
          'IS_CHARGER_CONTENANTS': {
            'typeParam': 'boolean',
            'valeur': true
          },
          'IS_CHARGER_MOUVEMENTS': {
            'typeParam': 'boolean',
            'valeur': true
          },
          'IS_CHARGER_BON_COMPLET': {
            'typeParam': 'boolean',
            'valeur': false
          },
          'IS_CHARGER_TOUS_BONS': {
            'typeParam': 'boolean',
            'valeur': false
          },
          'IS_CHARGER_CLIENT_COMPLET': {
            'typeParam': 'boolean',
            'valeur': false
          },
          'IS_CHARGER_SITE_COMPLET': {
            'typeParam': 'boolean',
            'valeur': false
          },
          'IS_CHARGER_CLIENT_COMPLET_CONTENANT': {
            'typeParam': 'boolean',
            'valeur': false
          },
          'IS_CHARGER_INFO_EQUIPE': {
            'typeParam': 'boolean',
            'valeur': false
          },
          'IS_CHARGER_PROGRAM_COMPLET': {
            'typeParam': 'boolean',
            'valeur': true
          },
          'IS_CHARGER_PRESENCE_MOUVEMENTS': {
            'typeParam': 'boolean',
            'valeur': true
          },
          'IS_CHARGER_NB_CONTENANT': {
            'typeParam': 'boolean',
            'valeur': true
          },
          'CLEF_MOUVEMENT': {
            'typeParam': 'int',
            'valeur': clefMvt || 0
          },
          // 'CRITERE': event || '',
        }
      }
    };
    if (event) {
      param.data['CLEF_TOURNEE'] = {
        'typeParam': 'int',
        'valeur': event
      };
    }

    return this.common.post('', { param: param }).then(datas => {
      if (this.common.verifySession(datas)) {
        if (datas.data) {
          this.detailTournee = datas.data || {};
        }
      }
    });
  }

  editMvtTourne() {
    const heure = this.hourMvt();
    const tourne = Object.assign({}, this.detailTournee);
    tourne.nomclass = 'Tournee';
    const sitePrest = this.isShowSite ? (this.newprest['sitePrest'] ? this.newprest['sitePrest'].id
      : this.common.user[2]) : this.common.user[2];
    this.detailTournee['listeMouvements'].forEach(elt => {
      elt.tournee = {
        id: tourne.id,
        nomclass: 'Tournee'
      };
      elt.nomclass = 'Mouvement';
      if (this.info['mouvement'] && elt.id === this.info['mouvement'].id) {
        // sarobidy
        elt.dateEnlevement = moment(this.newprest['dateStart']).format('YYYY-MM-DD');
        elt.heure = heure;
        elt.operation = (this.newprest['typeOperation'] ? this.newprest['typeOperation'].id : '0'); // choix operation
        elt.exutoire = {
          id: '' + (this.newprest['exutoire'] ? (this.newprest['exutoire'].id || '0') : '0')
        };
        elt.clefSitePrest = sitePrest;
        elt.sitePrestation = {
          id: sitePrest
        };
        elt.majContenant = true;
        elt.listBenne = this.detailTournee['listeContenants'] || [];
      }
    });
    const param = {
      'servlet': 'DBGestionTournee',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'true',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 6
        },
        'CLEF_TOURNEE': {
          'typeParam': 'int',
          'valeur': this.detailTournee['id']
        },
        'LISTE_MOUVEMENTS': this.detailTournee['listeMouvements'],
        /*'ACTUALISER_PROGRAM': {
          'typeParam': 'boolean',
          'valeur': true
        },*/
        // 'PROGRAM': this.info['program'] || {},
        'USER': {
          'typeParam': 'int',
          'valeur': this.common.user[0]
        },
      }
    };

    if (this.detailTournee['program']) {
      this.detailTournee['program'].nomclass = 'MouvementBenneProgramme';
      param.data['PROGRAM'] = this.detailTournee['program'] || {};
      param.data['ACTUALISER_PROGRAM'] = {
        'typeParam': 'boolean',
        'valeur': true
      };
    }

    if (this.societe['ecobennesEquipe']) {
      this.detailTournee['nomclass'] = 'Tournee';
      param.data['TOURNEE'] = this.detailTournee;
    }

    // console.log(JSON.stringify(param))
    return this.common.post('', { param: param }).then(datas => {
      if (this.common.verifySession(datas)) {
        this.updateClientChantier(true);
      }
    });
  }

  findCouleur() {
    if (this.info['listContenantTournee'] && this.info['listContenantTournee'][0]) {
      const artPAV = this.info['listContenantTournee'][0].art;
      return artPAV.couleurPAV || '#1eafba';
    }
  }

  toogleSlideTournee() {
    this.isAddContTournee = !this.isAddContTournee;
  }

  addContenantTournee(event) {
    this.detailTournee['listeContenants'].push(event);
    this.detailTournee['listeContenants'] = [...this.detailTournee['listeContenants']];
    /*this.info['listContenantTournee'] = this.info['listContenantTournee'] || [];
    this.info['listContenantTournee'].push(event);*/
    /*if (this.detailTournee['id']) {
      this.saveContenantTournee(event.id, 1);
    }*/
  }

  deleteLigne(item) {
    // this.info['listContenantTournee'] = this.info['listContenantTournee'].filter(elt => elt !== item);
    this.detailTournee['listeContenants'] = this.detailTournee['listeContenants'].filter(elt => elt !== item);
    // this.saveContenantTournee(item.id, 2);
  }

  saveContenantTournee(idBenneData, operation) {
    this.detailTournee['nomclass'] = 'Tournee';
    const param = {
      'servlet': 'DBGestionTournee',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'true',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 2
        },
        'TOURNEE': this.detailTournee,
        'CLEF_BENNE': {
          'typeParam': 'int',
          'valeur': idBenneData
        },
        'ACTUALISER_BON_MOUVEMENTS': {
          'typeParam': 'boolean',
          'valeur': true
        },
        'OP_LISTE': {
          'typeParam': 'int',
          'valeur': operation
        },
      }
    };

    return this.common.post('', { param: param });
  }

  getLogs(n) {
    if (n['listBon'].length > 0) {
      this.common.getLogs(n['listBon'][0].id, '43', this.modalService);
    }
  }

  addContenantDepot() {
    this.contenantDepot = { qteContenant: 1 };

    setTimeout(function () {
      $('.operationBac').click();
    }, 550);
  }

  getListTypeCont() {
    const param = {
      'servlet': 'DBGetListTypCont',
      'module': 'Recylog',
      'type': 'tableau',
      'compression': 'false',
      'data': ['']
    };

    this.common.post('', { param: param }).then(datas => {
      if (this.common.verifySession(datas) && datas.data != null) {
        this.listTypeContDepot = [];
        datas.data.forEach(elt => {
          // if (elt.famille && elt.famille.bac) {
          elt.libelleObjetEntite = (elt.famille.libelle ? elt.famille.libelle + ' ' : '')
            + (elt.cubage.cubage ? elt.cubage.cubage : '')
            + (elt.uniteCont.libelle ? elt.uniteCont.libelle : '');
          this.listTypeContDepot.push(elt);
          // }
        });

      }
    });
  }

  searchArticleDepot(event, grp?) {
    const param = 14;


    return this.common.appelComboK3Fct(param, event).then(datas => {
      // $('.articleCont').trigger('click');
      if (this.common.verifySession(datas)) {
        this.dataArticleDepot = datas.data;
      }
    });
  }

  showFacturation() {
    console.log('test ', this.isClickFacturation)
    if (this.newprest['newContenant']) {
      if (this.isEditChantier) {
        this.contenantFact = this.newprest['newBenne'];
      } else {
        this.contenantFact = this.newBenne;
      }
    } else {
      this.contenantFact = this.newprest['contenant'];
    }
    this.isClickFacturation = !this.isClickFacturation;
  }

  saveLocationFact(event) {
    console.log('test', this.contenantFact);
    console.log('test event', event);
  }

  addArticlesNewBenne() {
    this.selactedArticle = { add: true };
    this.newBenne['listArticle'] = this.newBenne['listArticle'] || [];

    this.newBenne['listArticle'].push(this.selactedArticle);
    const index = this.newBenne['listArticle'].length - 1;
    setTimeout(function () {
      $('.articlegrp').focus();
    }, 650);
  }


  addArticlesContenant() {
    this.selactedArticle = { add: true };
    if (this.newprest['contenant']) {
      this.newprest['contenant'].listArticle = this.newprest['contenant'].listArticle || [];

      this.newprest['contenant'].listArticle.push(this.selactedArticle);
      const index = this.newprest['contenant'].listArticle.length - 1;
      setTimeout(function () {
        $('.articlegrp').focus();
      }, 650);
    }
  }

  addArticlesNewprest() {
    this.selactedArticle = { add: true };
    if (this.newprest['newBenne']) {
      this.newprest['newBenne'].listArticle = this.newprest['newBenne'].listArticle || [];

      this.newprest['newBenne'].listArticles.push(this.selactedArticle);
      const index = this.newprest['newBenne'].listArticles.length - 1;
      setTimeout(function () {
        $('.articlegrp').focus();
      }, 650);
    }
  }

  deleteListArticles(listArticles, item) {
    const index = listArticles.indexOf(item);
    if (index > -1) {
      listArticles.splice(index, 1);
    }
  }


  showArticleGrp() {
    this.listArticle = [];
    this.addArticle = !this.addArticle;
  }


  modifierLeContenant() {
    this.isModifierLeContenant = true;
  }

  saveModifContenant() {
    this.benneChantier = this.newprest['contenant'];
    this.benneChantier['qteContenant'] = this.benneChantier['qteContenant'] ? parseInt(this.benneChantier['qteContenant'], 10) : 1;
    const isClient = this.newprest['client'] && this.newprest['client'].id ? true : false;
    const isChantier = this.newprest['chantier'] && this.newprest['chantier'].id ? true : false;
    const isArticle = this.benneChantier['isGroupeArticle'] ? true : (this.benneChantier['art'] && this.benneChantier['art'].id ? true : false);
    const isExutoire = this.newprest['exutoire'] && this.newprest['exutoire'].id ? true : false;
    const isTypecont = this.benneChantier['typeContenant'] && this.benneChantier['typeContenant'].id ? true : false;
    const isGoupe = this.benneChantier['isGroupeBenne'] || false;
    const listBennes = this.benneChantier['listBennes'] || [];
    // if (this.benneChantier['listArticle']) {
    //   this.benneChantier['listArticle'].forEach(elt => elt.nomclass = 'Article');
    // }

    if (this.benneChantier['isGroupeArticle'] && !this.benneChantier['listArticle'].length) {
      this.error = 'Votre groupe d\'article doit comporter au moins un article.';
      this.isClicked = false;
      this.common.openModal(this.modalService, this.msg);
      return;
    }

    if (this.benneChantier['listArticle']) {
      this.benneChantier['listArticles'] = [];
      this.benneChantier['listArticle'].forEach(elt => {
        const art = Object.assign({}, elt.art);
        art.exu = Object.assign({}, elt.exutoire);
        art.nomclass = 'Article';
        this.benneChantier['listArticles'].push(art);
      });
    }

    if (this.benneChantier['listBennes']) {
      this.benneChantier['listBennes'].forEach(elt => {
        if (elt.id < 0) {
          elt.id = 0;
        }
        elt.nomclass = 'BenneData';
        elt.operation = elt.operationBenne ? (elt.operationBenne['id'] || '2') : '2';
        elt.operationBenne = {
          id: elt.operationBenne ? (elt.operationBenne['id'] || '2') : '2'
        };
        // elt.nomclass = 'BenneData';
        // elt.operationBenne = {
        //   id: '2'
        // };
      });
    }
    this.updateBenneChantier(true).then(dat => {
      this.updateClientChantier(true);
    })
  }

  focustimeOut(elt) {
    const ctrl = this;

    setTimeout(function () {
      ctrl.common.focusElement(elt)
    }, 550);
  }

  showProgrammation() {
    if (this.newprest['program']) {
      this.isProgrammation = !this.isProgrammation;
    }
  }

  showMouvPlus() {
    if (this.newprest['mouvSupp']) {
      this.isMouvSupp = !this.isMouvSupp;
    }
  }


  getToutesRsrcBSDDPlanningGeneral() {
    const listToutesRessourcesBSDDPlanning = [];

    console.log(this.info['bonSelected'], this.info['mouvement'])
    if (this.info['bonSelected'] && this.info['bonSelected'].typeBon && this.info['bonSelected'].typeBon.id !== 1 &&
      this.info['bonSelected'].typeBon.id !== 4 && !this.isHisto && !this.isHistoMvt) {
      if (this.info['mouvement'] && this.info['mouvement'].id) {
        listToutesRessourcesBSDDPlanning.push(this.info['mouvement']);
      }
    }

    if (listToutesRessourcesBSDDPlanning.length > 0) {
      // console.log(this.listToutesRessourcesBSDDPlanning);
      this.imprimerTousLesBSDD(listToutesRessourcesBSDDPlanning);
    } else {
      this.error = 'Aucun BSDD \u00e0 imprimer sur ce bon.';
      this.common.openModal(this.modalService, this.msg);
    }
  }

  imprimerTousLesBSDD(listToutesRessourcesBSDDPlanning) {
    const promise = [];
    const ctrl = this;
    const listId = [];
    listToutesRessourcesBSDDPlanning.forEach(ressource => {
      listId.push('' + ressource.id);
      // promise.push(GestionBsdd.printBSDDMouv(ressource.id, ctrl.common));
    });
    GestionBsdd.printBSDDMouv(listId, ctrl.common).then(datas => {
      if (this.common.verifySession(datas)) {
        if (datas.data && datas.data.length) {
          if (datas.data !== 'KO') {
            const url = datas.data[0]; // GestionBsdd.getUrlBsdd(datas.data);
            this.common.openFile(url);
          } else {
            this.error = `Aucun BSDD \u00e0 imprimer sur ce bon.
            V\u00e9rifiez :
            - Le bon contient un DD
            - Il ne s'agit pas d'un depot
            - Le client est configur\u00e9 pour imprimer des BSDDs pour des d\u00e9chets non DD
            `;
            this.common.openModal(this.modalService, this.msg);
          }
          console.log(datas.data);
        } else {
          if (datas.message) {
            this.error = datas.message;
            this.common.openModal(this.modalService, this.msg);
          }
        }
      }
    });
  }

}
